import React from "react";
import DataTable from "./../../partials/table/DataTables.js";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import conf from "./../../../config.js";
import SelectJs from "./../../partials/Select.js";
import axios from "axios";
import tokenApi from "../../auth/Helpers";
import { render } from "@testing-library/react";
import { Button, Modal } from "react-bootstrap";
import SweetAlert from "sweetalert2-react";
import Select from "react-select";
import Skeleton from "react-loading-skeleton";
import { useChecklist } from "react-checklist";

import { UserButtonLoading } from "../../partials/loadings/ComponentLoading.js";
import { isEmpty } from "lodash";
import { capitalize } from "@material-ui/core";

// Custom select styles with modern look
const selectStyles = {
  control: (styles, { isFocused }) => ({
    ...styles,
    borderRadius: "12px",
    minWidth: "12rem",
    border: isFocused ? "2px solid #6366f1" : "1px solid #e5e7eb",
    boxShadow: isFocused ? "0 0 0 3px rgba(99, 102, 241, 0.1)" : "none",
    "&:hover": {
      borderColor: "#6366f1",
    },
  }),
  option: (styles, { isSelected, isFocused }) => ({
    ...styles,
    backgroundColor: isSelected ? "#6366f1" : isFocused ? "#eef2ff" : "white",
    color: isSelected ? "white" : "#1f2937",
  }),
};

const dataKurikulum = [
  { value: "k13", label: "K13" },
  { value: "merdeka", label: "Merdeka" },
];

function captFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export default class TambahKenaikanSiswa extends React.Component {
  selectRef = null;
  selectReff = null;
  constructor(props) {
    super(props);
    this.state = {
      url: `${conf.uri_backend}api/v1/rombel/table-kenaikan`,
      url_table_kenaikan_filter: `${conf.uri_backend}api/v1/rombel/table-kenaikan-filter`,
      url_naik_kelas: `${conf.uri_backend}api/v1/rombel/kenaikan`,
      url_get_rombel: `${conf.uri_backend}api/v1/rombel/get_rombel`,
      url_get_spektrum: `${conf.uri_backend}api/v1/rombel/get_spektrum`,
      url_get_filter: `${conf.uri_backend}api/v1/rombel/filter`,
      url_tambah_alumni: `${conf.uri_backend}api/v1/rombel/alumni`,
      url_get_smk: `${conf.uri_backend}api/v1/referensi/struktur-kurikulum`,
      url_show_data: "",
      search: false,
      tahunSekarang: new Date().getFullYear(),
      // alert
      show_alert: false,
      title_alert: "",
      message_alert: "",
      icon_alert: "",

      tahun_ajaran_search: null,
      filterKurikulumSearch: "",
      kelas_search: "",
      peminatan_search: "",

      peminatan_search_baru: "",

      rombel_search: "",
      bidang_search: "",
      program_search: "",
      kompetensi_search: "",

      bidang_search_baru: "",
      program_search_baru: "",
      kompetensi_search_baru: "",
      searchText: "",

      data_tahun_ajaran: [],
      data_kelas: [],
      data_peminatan: [],
      data_peminatan_baru: [],
      data_bidang: [],
      data_program: [],
      data_kompetensi: [],
      data_rombel: [],

      loadingFilter: true,
      urutanFilter: true,
      selectedStudents: new Map(), // Initialize selection map
      showConfirmModal: false,
      showResultModal: false,
      showTargetSelectionModal: false, // For selecting which prepared target to use
      preparedTargets: [], // List of prepared destination rombels
      resultData: null,
      loading_submit: false,
      checkAll: false,
      check_all: false,
      check_item: false,
      check_id: "",
      showFilter: true,
      showDataTable: false,
      query: "",

      mode_show: 10,

      filterTahunAjaran: "",
      filterKelas: "",
      filterPeminatan: "",
      filterPeminatanBaru: "",
      filterRombel: "",

      // Target Rombel State
      target_tahun_ajaran: "",
      target_kurikulum: "",
      target_kelas: "",
      target_rombel_id: "",
      target_rombel_label: "",
      data_target_rombel: [],
      loading_target_rombel: false,

      // Phase 3: Premium Redesign State
      assignedStudents: {}, // { [targetId]: [student1, student2, ...] }
      expandedTargets: {}, // { [targetId]: true/false }
      showSourceFilter: false, // Collapsed by default - filter for source rombel
      showTargetPanel: true, // Show target panel by default
      searchQuery: "", // Inline search
      draggedStudents: [], // Currently being dragging students
    };
    // get option filter
    this.getTahunAjaranNow = this.getTahunAjaranNow.bind(this);
    this.getKelas = this.getKelas.bind(this);
    this.getRombel = this.getRombel.bind(this);
    this.getPeminatanSMA = this.getPeminatanSMA.bind(this);
    this.getDataFilterSMA = this.getDataFilterSMA.bind(this);
    this.getBidang = this.getBidang.bind(this);
    this.getProgram = this.getProgram.bind(this);
    this.getKompetensi = this.getKompetensi.bind(this);
    // filter and search
    this.filterTahunAjaran = this.filterTahunAjaran.bind(this);
    this.filterKurikulume = this.filterKurikulume.bind(this);
    this.filterKelas = this.filterKelas.bind(this);
    // this.filterKurikulum = this.filterKurikulum.bind(this);
    this.filterRombel = this.filterRombel.bind(this);
    this.filterPeminatan = this.filterPeminatan.bind(this);
    this.filterBidang = this.filterBidang.bind(this);
    this.filterProgram = this.filterProgram.bind(this);
    this.filterKompetensi = this.filterKompetensi.bind(this);
    this.urutanJenjang = this.urutanJenjang.bind(this);
    this.searchText = this.searchText.bind(this);

    this.filterBidangBaru = this.filterBidangBaru.bind(this);
    this.filterProgramBaru = this.filterProgramBaru.bind(this);
    this.filterKompetensiBaru = this.filterKompetensiBaru.bind(this);

    // show select filter
    this.showSelectFilterSD = this.showSelectFilterSD.bind(this);
    this.showSelectFilterSMA = this.showSelectFilterSMA.bind(this);
    this.showSelectFilterSMK = this.showSelectFilterSMK.bind(this);
    this.showSelectFilterALL = this.showSelectFilterALL.bind(this);
    this.formFilter = this.formFilter.bind(this);
    this.clickFilter = this.clickFilter.bind(this);

    // this.getDataTable = this.getDataTable.bind(this);
    // processing  Data
    this.setFilter = this.setFilter.bind(this);
    this.showData = this.showData.bind(this);
    this.setResetFilter = this.setResetFilter.bind(this);
    // Save data
    this.naikKelas = this.naikKelas.bind(this);
    this.tambahAlumni = this.tambahAlumni.bind(this);

    this.selectAll = this.selectAll.bind(this);
    this.selectOne = this.selectOne.bind(this);
    this.checkAll = this.checkAll.bind(this);
    this.unCheckAll = this.unCheckAll.bind(this);
    this.showMode = this.showMode.bind(this);
    this.selectOne = this.selectOne.bind(this);
    this.checkAll = this.checkAll.bind(this);
    this.unCheckAll = this.unCheckAll.bind(this);
    this.showMode = this.showMode.bind(this);

    // Target Handlers
    this.handleTargetTahunAjaran = this.handleTargetTahunAjaran.bind(this);
    this.handleTargetKurikulum = this.handleTargetKurikulum.bind(this);
    this.handleTargetKelas = this.handleTargetKelas.bind(this);
    this.handleTargetRombel = this.handleTargetRombel.bind(this);
    this.fetchTargetRombel = this.fetchTargetRombel.bind(this);
  }

  componentDidMount() {
    // get session user
    if (localStorage.getItem("token") !== null) {
      axios
        .post(`${conf.uri_backend}api/v1/auth/sso/user`, {
          token: localStorage.getItem("token"),
        })
        .then((res) => {
          this.setState({ data_session: res.data }, function () {
            axios
              .get(
                `${conf.uri_backend}api/v1/select-institusi/` +
                  this.state.data_session.access_to,
                { headers: { Authorization: tokenApi } },
              )
              .then((res) => {
                this.setState(
                  {
                    institusi_id_select: res.data.id,
                    jenjang_id_select: res.data.m_struktur_jenjang_id,
                  },
                  function () {
                    // Load filter history from localStorage
                    this.loadFilterHistory();
                    this.getDataFilterSMA();
                    // Auto-load all data on mount so students are visible immediately
                    this.loadAllData();
                  },
                );
              });
          });
        });
    }
  }

  // Load all data without filter — shows all rombel/siswa for this institution
  loadAllData() {
    const defaultQuery =
      "&user_institusi_id=" +
      this.state.institusi_id_select +
      "&has_rombel=true" +
      "&paginate=" +
      this.state.mode_show;
    this.setState(
      {
        url_show_data: this.state.url,
        query: defaultQuery,
        showDataTable: true,
        search: false,
      },
      function () {
        if (this.dt) {
          this.dt.loading();
          this.dt.resetPage(this.state.query);
        }
      },
    );
  }

  // ============================================
  // localStorage History Methods
  // ============================================

  loadFilterHistory = () => {
    try {
      const saved = localStorage.getItem(this.getFilterStorageKey());
      if (saved) {
        const history = JSON.parse(saved);
        this.setState({
          tahun_ajaran_search:
            history.tahun_ajaran || this.state.tahun_ajaran_search,
          filterKurikulumSearch:
            history.kurikulum || this.state.filterKurikulumSearch,
          kelas_search: history.kelas || this.state.kelas_search,
          // SMK fields
          bidang_search: history.bidang_id || this.state.bidang_search,
          bidang_search_label:
            history.bidang_label || this.state.bidang_search_label,
          program_search: history.program_id || this.state.program_search,
          program_search_label:
            history.program_label || this.state.program_search_label,
          kompetensi_search:
            history.kompetensi_id || this.state.kompetensi_search,
          kompetensi_search_label:
            history.kompetensi_label || this.state.kompetensi_search_label,
          // SMA peminatan
          peminatan_search: history.peminatan_id || this.state.peminatan_search,
          peminatan_search_label:
            history.peminatan_label || this.state.peminatan_search_label,
          // Rombel
          rombel_search: history.rombel_id || this.state.rombel_search,
          rombel_search_label:
            history.rombel_label || this.state.rombel_search_label,
        });
      }
    } catch (e) {
      console.warn("Failed to load filter history:", e);
    }
  };

  saveFilterHistory = () => {
    try {
      const history = {
        tahun_ajaran: this.state.tahun_ajaran_search,
        kurikulum: this.state.filterKurikulumSearch,
        kelas: this.state.kelas_search,
        // SMK fields
        bidang_id: this.state.bidang_search,
        bidang_label: this.state.bidang_search_label,
        program_id: this.state.program_search,
        program_label: this.state.program_search_label,
        kompetensi_id: this.state.kompetensi_search,
        kompetensi_label: this.state.kompetensi_search_label,
        // SMA peminatan
        peminatan_id: this.state.peminatan_search,
        peminatan_label: this.state.peminatan_search_label,
        // Rombel
        rombel_id: this.state.rombel_search,
        rombel_label: this.state.rombel_search_label,
        savedAt: new Date().toISOString(),
      };
      localStorage.setItem(this.getFilterStorageKey(), JSON.stringify(history));
    } catch (e) {
      console.warn("Failed to save filter history:", e);
    }
  };

  getFilterStorageKey = () => {
    return `kenaikanSiswa_filterHistory_${this.state.institusi_id_select}`;
  };

  clearFilterHistory = () => {
    try {
      localStorage.removeItem(this.getFilterStorageKey());
    } catch (e) {
      console.warn("Failed to clear filter history:", e);
    }
  };

  // Alias for loadAllData - called from getDataFilterSMA
  loadAllStudentsWithRombel = () => {
    this.loadAllData();
  };

  alertMessage(e) {
    let message = null;

    switch (e.status) {
      case 422:
        message = e.data.messages[0];
        break;
      case 500:
        message =
          "Ada yang Salah, Coba Beberapa Saat Lagi atau Segera Hubungi Admin 😊";
        break;
      case 404:
        message = "Url Not Found, Coba Hubungi Admin 😊";
        break;
      case 401:
        message =
          "Nauthorized, Coba Beberapa Saat Lagi atau Segera Hubungi Admin 😊";
        break;
      case 400:
        message =
          "Koneksi Buruk, Coba Beberapa Saat Lagi atau Segera Hubungi Admin 😊";
        break;
      case 408:
        message =
          "Request Timeout, Coba Beberapa Saat Lagi atau Segera Hubungi Admin 😊";
        break;
      case 429:
        message =
          "Too Many Request, Coba Beberapa Saat Lagi atau Segera Hubungi Admin 😊";
        break;
      case 405:
        message =
          "Method Tidak Diperbolehkan, Coba Beberapa Saat Lagi atau Segera Hubungi Admin 😊";
        break;
    }

    this.setState({
      show_alert: true,
      title_alert: "Gagal",
      icon_alert: "error",
      message_alert: message,
      simpleLoading: false,
    });
  }

  showMode(num) {
    var m_spektrum = "";
    if (
      this.state.jenjang_id_select == "5"
        ? (m_spektrum = this.state.kompetensi_search)
        : (m_spektrum = this.state.peminatan_search)
    );

    this.setState(
      {
        mode_show: num,
        query:
          "&has_rombel=true" +
          "&tahun_ajaran=" +
          this.state.tahun_ajaran_search +
          "&kelas=" +
          this.state.kelas_search +
          "&m_spektrum_id=" +
          m_spektrum +
          "&user_institusi_id=" +
          this.state.institusi_id_select +
          "&query=" +
          this.state.searchText +
          "&paginate=" +
          num,
      },
      function () {
        if (this.dt) {
          this.dt.loading();
          this.dt.resetPage(this.state.query);
        }
      },
    );
  }

  // Search text method for filtering students by name/code
  searchText(e) {
    var m_spektrum = "";
    if (
      this.state.jenjang_id_select == "5"
        ? (m_spektrum = this.state.kompetensi_search)
        : (m_spektrum = this.state.peminatan_search)
    );

    const searchValue = e?.target?.value || "";

    this.setState(
      {
        searchText: searchValue,
        query:
          "&has_rombel=true" +
          "&tahun_ajaran=" +
          this.state.tahun_ajaran_search +
          "&kelas=" +
          this.state.kelas_search +
          "&m_spektrum_id=" +
          m_spektrum +
          "&user_institusi_id=" +
          this.state.institusi_id_select +
          "&query=" +
          searchValue +
          "&paginate=" +
          this.state.mode_show,
      },
      function () {
        if (this.dt) {
          this.dt.loading();
          this.dt.resetPage(this.state.query);
        }
      },
    );
  }

  getTahunAjaranNow() {
    var ta = [];
    var u = this.state.tahunSekarang + 1;
    var tahun_sekarang = this.state.tahunSekarang + 1;

    for (var i = tahun_sekarang; i >= 2005; i--) {
      u = u - 1;
      ta.push({ value: u + " / " + i, label: u + " / " + i });
    }
    this.setState({ data_tahun_ajaran: ta });
  }

  getKelas() {
    var kelas = [];
    if (this.state.jenjang_id_select == "1") {
      kelas = [
        { value: "TPA", label: "TPA (Taman Penitipan Anak)" },
        { value: "SPS", label: "SPS (Satuan PAUD Sejenis)" },
        { value: "KB", label: "KB (Kelompok Bermain)" },
        { value: "TK A", label: "TK A" },
        { value: "TK B", label: "TK B" },
      ];
    } else if (this.state.jenjang_id_select == "2") {
      kelas = [
        { value: "I", label: "I" },
        { value: "II", label: "II" },
        { value: "III", label: "III" },
        { value: "IV", label: "IV" },
        { value: "V", label: "V" },
        { value: "VI", label: "VI" },
      ];
    } else if (this.state.jenjang_id_select == "3") {
      kelas = [
        { value: "VII", label: "VII" },
        { value: "VIII", label: "VIII" },
        { value: "IX", label: "IX" },
      ];
    } else if (this.state.jenjang_id_select == "4") {
      kelas = [
        { value: "X", label: "X" },
        { value: "XI", label: "XI" },
        { value: "XII", label: "XII" },
      ];
    } else if (this.state.jenjang_id_select == "5") {
      kelas = [
        { value: "X", label: "X" },
        { value: "XI", label: "XI" },
        { value: "XII", label: "XII" },
        { value: "XIII", label: "XIII" },
      ];
    }
    this.setState({ data_kelas: kelas });
  }

  getPeminatanSMA() {
    this.setState({ loading_peminatan: !this.state.loading_peminatan });
    if (this.state.jenjang_id_select == "4") {
      let filterKurikulum = this.state.filterKurikulumSearch
        ? this.state.filterKurikulumSearch
        : "k13";
      axios
        .get(
          this.state.url_get_spektrum +
            "?jenjang=" +
            this.state.jenjang_id_select +
            "&kurikulum=" +
            filterKurikulum,
          { headers: { Authorization: tokenApi } },
        )
        .then((res) => {
          if (res.data.status == true) {
            this.setState({ data_peminatan: res.data.data });
            this.setState({ data_peminatan_baru: res.data.data });
            this.setState({ loading_peminatan: false });
          } else {
            this.setState({ data_peminatan: [] });
            this.setState({ data_peminatan_baru: [] });
            this.setState({ loading_peminatan: false });
          }
        });
    }
  }

  // SMK
  getBidang() {
    if (this.state.jenjang_id_select == 5) {
      this.setState({ loading_bidang: !this.state.loading_bidang });
      axios
        .get(
          `${this.state.url_get_smk}?parent_id=0&jenjang_id=5&kurikulum=${this.state.filterKurikulumSearch}`,
          {
            headers: { Authorization: tokenApi },
          },
        )
        .then((res) => {
          this.setState({ data_bidang: res.data });
          this.setState({ loading_bidang: false });
        })
        .catch((err) => {
          this.setState({ loading_bidang: false });
        });
    }
  }
  getProgram() {
    if (this.state.jenjang_id_select == 5) {
      this.setState({ loading_program: !this.state.loading_program });
      axios
        .get(
          `${this.state.url_get_smk}?parent_id=${this.state.bidang_search}&jenjang_id=5&kurikulum=${this.state.filterKurikulumSearch}`,
          { headers: { Authorization: tokenApi } },
        )
        .then((res) => {
          this.setState({ data_program: res.data });
          this.setState({ loading_program: false });
        })
        .catch((err) => {
          this.setState({ loading_program: false });
        });
    }
  }
  getKompetensi(create) {
    if (this.state.jenjang_id_select == 5) {
      this.setState({ loading_kompetensi: !this.state.loading_kompetensi });
      axios
        .get(
          `${this.state.url_get_smk}?parent_id=${this.state.program_search}&jenjang_id=5&kurikulum=${this.state.filterKurikulumSearch}`,
          { headers: { Authorization: tokenApi } },
        )
        .then((res) => {
          this.setState({ data_kompetensi: res.data });
          this.setState({ loading_kompetensi: false });
        })
        .catch((err) => {
          this.setState({ loading_kompetensi: false });
        });
    }
  }

  getBidangBaru() {
    if (this.state.jenjang_id_select == 5) {
      this.setState({ loading_bidang: !this.state.loading_bidang });
      axios
        .get(
          `${this.state.url_get_smk}?parent_id=0&jenjang_id=5&kurikulum=${this.state.filterKurikulumSearch}`,
          {
            headers: { Authorization: tokenApi },
          },
        )
        .then((res) => {
          this.setState({ data_bidang: res.data });
          this.setState({ loading_bidang: false });
        })
        .catch((err) => {
          this.setState({ loading_bidang: false });
        });
    }
  }
  getProgramBaru() {
    if (this.state.jenjang_id_select == 5) {
      this.setState({ loading_program: !this.state.loading_program });
      axios
        .get(
          `${this.state.url_get_smk}?parent_id=${this.state.bidang_search}&jenjang_id=5&kurikulum=${this.state.filterKurikulumSearch}`,
          { headers: { Authorization: tokenApi } },
        )
        .then((res) => {
          this.setState({ data_program: res.data });
          this.setState({ loading_program: false });
        })
        .catch((err) => {
          this.setState({ loading_program: false });
        });
    }
  }

  getKompetensiBaru(create) {
    if (this.state.jenjang_id_select == 5) {
      this.setState({ loading_kompetensi: !this.state.loading_kompetensi });
      axios
        .get(
          `${this.state.url_get_smk}?parent_id=${this.state.program_search}&jenjang_id=5&kurikulum=${this.state.filterKurikulumSearch}`,
          { headers: { Authorization: tokenApi } },
        )
        .then((res) => {
          this.setState({ data_kompetensi: res.data });
          this.setState({ loading_kompetensi: false });
        })
        .catch((err) => {
          this.setState({ loading_kompetensi: false });
        });
    }
  }

  // e = kelas, b = peminatan (optional overrides)
  getRombel(e, b) {
    this.setState({ loading_rombel: true });

    // Determine the correct peminatan/spektrum based on jenjang and kurikulum
    let peminatan = "";
    if (this.state.jenjang_id_select == "5") {
      // SMK
      if (this.state.filterKurikulumSearch === "merdeka") {
        // Merdeka: use program (no kompetensi level)
        peminatan = b || this.state.program_search || "";
      } else {
        // K13: use kompetensi
        peminatan = b || this.state.kompetensi_search || "";
      }
    } else {
      // SD/SMP/SMA: use peminatan
      peminatan = b || this.state.peminatan_search || "";
    }

    let filterKurikulum = this.state.filterKurikulumSearch
      ? this.state.filterKurikulumSearch
      : "k13";

    let kelas = e || this.state.kelas_search || "";

    if (e) {
      this.setState({
        filterPeminatanBaru: b,
        filterKelas: e,
        loading_rombel_baru: true,
        loading_peminatan_baru: true,
      });
    }

    axios
      .get(
        `${this.state.url_get_rombel}?tahun_ajaran=${this.state.tahun_ajaran_search}&kelas=${kelas}&peminatan=${peminatan}&user_institusi_id=${this.state.institusi_id_select}&kurikulum=${filterKurikulum}`,
        { headers: { Authorization: tokenApi } },
      )
      .then((res) => {
        this.setState({
          data_rombel: res.data,
          loadingFilter: false,
          loading_rombel_baru: false,
          loading_rombel: false,
          loading_peminatan_baru: false,
        });
      })
      .catch(() => {
        this.setState({
          loading_rombel: false,
          loading_rombel_baru: false,
          loading_peminatan_baru: false,
        });
      });
  }

  showSelectFilterBaru() {
    if (this.state.jenjang_id_select == "4") {
      return (
        <div className="flex w-1/5">
          <div className="py-2 mr-2">
            <Select
              id="filterPeminatan"
              styles={selectStyles}
              // isClearable={true}
              isLoading={this.state.loading_peminatan ? true : false}
              isDisabled={this.state.disabledFilter}
              defaultValue={
                this.state.peminatan_search != ""
                  ? {
                      value: this.state.peminatan_search,
                      label: this.state.peminatan_search_label,
                    }
                  : ""
              }
              options={this.state.data_peminatan}
              onChange={this.filterPeminatan}
              placeholder={"Pilih Peminatan"}
            />
          </div>
        </div>
      );
    } else if (this.state.jenjang_id_select == "5") {
      return (
        <>
          {this.state.kelas_search != "" ? (
            <>
              <div className="py-2 ml-2">
                <Select
                  id="filterBidang"
                  styles={selectStyles}
                  isClearable={true}
                  defaultValue={
                    this.state.bidang_search != ""
                      ? {
                          value: this.state.bidang_search,
                          label: this.state.bidang_search_label,
                        }
                      : ""
                  }
                  isLoading={this.state.loading_bidang ? true : false}
                  options={this.state.data_bidang}
                  onChange={this.filterBidang}
                  className="animateFadeInLeft"
                  placeholder={
                    this.state.loading_bidang ? "Loading" : "Bidang Keahlian"
                  }
                />
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      );
    }
  }

  getDataFilterSMA() {
    axios
      .get(this.state.url_get_filter + "/" + this.state.institusi_id_select, {
        headers: { Authorization: tokenApi },
      })
      .then((res) => {
        if (res.data.status == true) {
          // Calculate correct current academic year based on month
          const month = new Date().getMonth();
          const year = new Date().getFullYear();
          const currentTA =
            month < 6 ? `${year - 1} / ${year}` : `${year} / ${year + 1}`;

          let options = res.data.tahun_ajaran.map(function (row) {
            return { value: row.tahun_ajaran, label: row.tahun_ajaran };
          });
          this.setState(
            {
              data_tahun_ajaran: options,
              tahun_ajaran_search:
                res.data.data.tahun_ajaran !== null
                  ? res.data.data.tahun_ajaran
                  : currentTA,
              kelas_search:
                res.data.data.kelas !== null ? res.data.data.kelas : "",
              bidang_search:
                res.data.data.bidang_id !== null ? res.data.data.bidang_id : "",
              bidang_search_label:
                res.data.data.bidang !== null ? res.data.data.bidang : "",
              program_search:
                res.data.data.program_id !== null
                  ? res.data.data.program_id
                  : "",
              program_search_label:
                res.data.data.program !== null ? res.data.data.program : "",
              kompetensi_search:
                res.data.data.kompetensi_id !== null
                  ? res.data.data.kompetensi_id
                  : "",
              kompetensi_search_label:
                res.data.data.kompetensi !== null
                  ? res.data.data.kompetensi
                  : "",
              peminatan_search:
                res.data.data.kompetensi_id !== null
                  ? res.data.data.kompetensi_id
                  : "",
              peminatan_search_label:
                res.data.data.kompetensi !== null
                  ? res.data.data.kompetensi
                  : "",
              rombel_search:
                res.data.data.rombel_id !== null ? res.data.data.rombel_id : "",
              rombel_search_label:
                res.data.data.rombel !== null ? res.data.data.rombel : "",
              filterKurikulumSearch:
                res.data.data.kurikulum !== null ? res.data.data.kurikulum : "",
              loadingFilter: false,
            },
            function () {
              // this.getDataTable();
              this.getTahunAjaranNow(); // This might overwrite data_tahun_ajaran if not careful
              this.getKelas();
              this.getPeminatanSMA();
              this.getRombel();
              this.getBidang();
              this.getProgram();
              this.getKompetensi();
              this.urutanJenjang();
              // AUTO-LOAD ALL STUDENTS WITH ROMBEL (no filter required)
              this.loadAllStudentsWithRombel();
            },
          );
        } else {
          this.setState({ loadingFilter: false });
          this.getTahunAjaranNow();
          this.getKelas(); // Load kelas options for target form
          // Still auto-load all students even if no saved filter
          this.loadAllStudentsWithRombel();
        }
      })
      .catch((err) => {
        // this.getDataTable();
        this.setState({ loadingFilter: false });
        this.getTahunAjaranNow();
        this.getKelas(); // Load kelas options for target form
        // Still auto-load all students even on error
        this.loadAllStudentsWithRombel();
      });
  }

  // Load all students who have a rombel assignment (no filter required)
  loadAllStudentsWithRombel = () => {
    this.setState(
      {
        url_show_data: `${this.state.url}`,
        query:
          "&user_institusi_id=" +
          this.state.institusi_id_select +
          "&has_rombel=true" +
          "&paginate=" +
          this.state.mode_show,
        search: true,
        showDataTable: true,
      },
      function () {
        if (this.dt) {
          this.dt.loading();
          this.dt.resetPage(this.state.query);
        }
      },
    );
  };

  // getDataTable(){
  //   var m_spektrum = '';
  //             if(this.state.jenjang_id_select == '5' ? m_spektrum = this.state.kompetensi_search : m_spektrum = this.state.peminatan_search);
  //             this.setState({
  //               query         : `&tahun_ajaran=${this.state.tahun_ajaran_search}`+
  //                       '&kelas='+this.state.kelas_search+
  //                       '&m_spektrum_id='+m_spektrum+
  //                       '&user_institusi_id='+this.state.institusi_id_select,
  //             }, function(){
  //               this.dt.fetchEntities(this.state.query);
  //             });
  // }

  // SHOW TYPE FILTER PER JENJANG
  showSelectFilterSD() {
    return (
      <>
        {this.state.data_tahun_ajaran != "" ? (
          <div className="flex w-1/5">
            <div className="py-2 mr-2">
              <Select
                id="filterTahunAjaran"
                styles={selectStyles}
                isDisabled={this.state.disabledFilter}
                defaultValue={
                  this.state.tahun_ajaran_search != null
                    ? {
                        value: this.state.tahun_ajaran_search,
                        label: this.state.tahun_ajaran_search,
                      }
                    : ""
                }
                options={this.state.data_tahun_ajaran}
                onChange={this.filterTahunAjaran}
                // className="animateFadeInLeft"
                placeholder={"Pilih Tahun Ajaran"}
              />
            </div>
          </div>
        ) : (
          ""
        )}
        <div className="flex w-1/5">
          <div className="py-2 mr-2">
            <Select
              styles={selectStyles}
              className="react-select__control"
              placeholder="Pilih Kurikulum"
              isDisabled={this.state.disabledFilter}
              defaultValue={
                this.state.filterKurikulumSearch != ""
                  ? {
                      value: this.state.filterKurikulumSearch,
                      label: this.state.filterKurikulumSearch,
                    }
                  : ""
              }
              options={dataKurikulum}
              onChange={(e) => {
                if (e) {
                  this.filterKurikulume(e);
                } else {
                  this.filterKurikulume("");
                }
              }}
            />
          </div>
        </div>
        {this.state.data_kelas != "" ? (
          <div className="flex w-1/5">
            <div className="py-2 mr-2">
              <Select
                id="filterKelas"
                styles={selectStyles}
                isClearable={true}
                isDisabled={this.state.disabledFilter}
                defaultValue={
                  this.state.kelas_search != ""
                    ? {
                        value: this.state.kelas_search,
                        label: this.state.kelas_search,
                      }
                    : ""
                }
                options={this.state.data_kelas}
                onChange={this.filterKelas}
                placeholder={"Pilih Kelas"}
              />
            </div>
          </div>
        ) : (
          ""
        )}
      </>
    );
  }

  showSelectFilterSMA() {
    if (this.state.jenjang_id_select == "4" && this.state.data_peminatan) {
      return (
        <div className="flex w-1/5">
          <div className="py-2 mr-2">
            <Select
              id="filterPeminatan"
              styles={selectStyles}
              // isClearable={true}
              isLoading={this.state.loading_peminatan ? true : false}
              isDisabled={this.state.disabledFilter}
              defaultValue={
                this.state.peminatan_search != ""
                  ? {
                      value: this.state.peminatan_search,
                      label: this.state.peminatan_search_label,
                    }
                  : ""
              }
              options={this.state.data_peminatan}
              onChange={this.filterPeminatan}
              placeholder={"Pilih Peminatan"}
            />
          </div>
        </div>
      );
    }
  }

  showSelectFilterSMK() {
    if (
      this.state.jenjang_id_select == "5" &&
      this.state.filterKurikulumSearch === "k13"
    ) {
      return (
        <>
          {this.state.kelas_search != "" ? (
            <>
              <div className="py-2 ml-2">
                <Select
                  id="filterBidang"
                  styles={selectStyles}
                  isClearable={true}
                  defaultValue={
                    this.state.bidang_search != ""
                      ? {
                          value: this.state.bidang_search,
                          label: this.state.bidang_search_label,
                        }
                      : ""
                  }
                  isLoading={this.state.loading_bidang ? true : false}
                  options={this.state.data_bidang}
                  onChange={this.filterBidang}
                  className="animateFadeInLeft"
                  placeholder={
                    this.state.loading_bidang ? "Loading" : "Bidang Keahlian"
                  }
                />
              </div>
            </>
          ) : (
            <></>
          )}
          {this.state.bidang_search != "" ? (
            <>
              <div className="py-2 ml-2">
                <Select
                  id="filterProgram"
                  styles={selectStyles}
                  isClearable={true}
                  defaultValue={
                    this.state.program_search != ""
                      ? {
                          value: this.state.program_search,
                          label: this.state.program_search_label,
                        }
                      : ""
                  }
                  isLoading={this.state.loading_program ? true : false}
                  options={this.state.data_program}
                  onChange={this.filterProgram}
                  placeholder={
                    this.state.loading_program ? "Loading" : "Program Keahlian"
                  }
                />
              </div>
            </>
          ) : (
            <></>
          )}
          {this.state.program_search != "" ? (
            <>
              <div className="py-2 ml-2">
                <Select
                  id="filterKompetensi"
                  styles={selectStyles}
                  isClearable={true}
                  defaultValue={
                    this.state.kompetensi_search != ""
                      ? {
                          value: this.state.kompetensi_search,
                          label: this.state.kompetensi_search_label,
                        }
                      : ""
                  }
                  isLoading={this.state.loading_kompetensi ? true : false}
                  options={this.state.data_kompetensi}
                  onChange={this.filterKompetensi}
                  placeholder={
                    this.state.loading_kompetensi
                      ? "Loading"
                      : "Kompetensi Keahlian"
                  }
                />
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      );
    }
    // For select kurikulum merdeka
    if (
      this.state.jenjang_id_select == "5" &&
      this.state.filterKurikulumSearch === "merdeka"
    ) {
      return (
        <>
          {this.state.kelas_search != "" ? (
            <>
              <div className="py-2 ml-2">
                <Select
                  id="filterBidang"
                  styles={selectStyles}
                  isClearable={true}
                  defaultValue={
                    this.state.bidang_search != ""
                      ? {
                          value: this.state.bidang_search,
                          label: this.state.bidang_search_label,
                        }
                      : ""
                  }
                  isLoading={this.state.loading_bidang ? true : false}
                  options={this.state.data_bidang}
                  onChange={this.filterBidang}
                  className="animateFadeInLeft"
                  placeholder={
                    this.state.loading_bidang ? "Loading" : "Bidang Keahlian"
                  }
                />
              </div>
            </>
          ) : (
            <></>
          )}
          {this.state.bidang_search != "" ? (
            <>
              <div className="py-2 ml-2">
                <Select
                  id="filterProgram"
                  styles={selectStyles}
                  isClearable={true}
                  defaultValue={
                    this.state.program_search != ""
                      ? {
                          value: this.state.program_search,
                          label: this.state.program_search_label,
                        }
                      : ""
                  }
                  isLoading={this.state.loading_program ? true : false}
                  options={this.state.data_program}
                  onChange={this.filterProgram}
                  placeholder={
                    this.state.loading_program ? "Loading" : "Program Keahlian"
                  }
                />
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      );
    }
  }

  showSelectFilterALL() {
    var kondisiJenjang = "";
    if (
      this.state.jenjang_id_select == 2 && this.state.kelas_search != ""
        ? (kondisiJenjang = true)
        : ""
    );
    if (
      this.state.jenjang_id_select == 3 && this.state.kelas_search != ""
        ? (kondisiJenjang = true)
        : ""
    );
    if (
      this.state.jenjang_id_select == 4 && this.state.peminatan_search != ""
        ? (kondisiJenjang = true)
        : ""
    );
    if (
      this.state.jenjang_id_select == 5 &&
      this.state.kompetensi_search != "" &&
      this.state.filterKurikulumSearch === "k13"
        ? (kondisiJenjang = true)
        : ""
    );
    if (
      this.state.jenjang_id_select == 5 &&
      this.state.program_search != "" &&
      this.state.filterKurikulumSearch === "merdeka"
        ? (kondisiJenjang = true)
        : ""
    );
    if (this.state.data_rombel) {
      return (
        <div className="flex w-1/5">
          <div className="py-2 mr-2">
            <Select
              id="filterRombel"
              styles={selectStyles}
              isClearable={true}
              isLoading={this.state.loading_rombel ? true : false}
              isDisabled={this.state.disabledFilter}
              defaultValue={
                this.state.rombel_search != ""
                  ? {
                      value: this.state.rombel_search,
                      label: this.state.rombel_search_label,
                    }
                  : ""
              }
              options={this.state.data_rombel}
              onChange={this.filterRombel}
              placeholder={
                this.state.data_rombel == "" ? "Rombel Kosong" : "Pilih Rombel"
              }
            />
          </div>
        </div>
      );
    } else {
      return (
        <div className="w-1/4 px-1">
          <div className="py-2">
            <Skeleton count={2} />
          </div>
        </div>
      );
    }
  }

  urutanJenjang() {
    if (
      this.state.tahun_ajaran_search != "" &&
      this.state.kelas_search != "" &&
      this.state.rombel_search != ""
    ) {
      if (
        this.state.jenjang_id_select == "3" ||
        this.state.jenjang_id_select == "2"
          ? this.setState({ urutanFilter: true })
          : ""
      );
      if (
        this.state.jenjang_id_select == "4" && this.state.peminatan_search != ""
          ? this.setState({ urutanFilter: true })
          : ""
      );
      if (
        this.state.bidang_search != "" &&
        this.state.program_search != "" &&
        this.state.kompetensi_search != ""
      ) {
        if (
          this.state.jenjang_id_select == "5"
            ? this.setState({ urutanFilter: true })
            : ""
        );
      }
    }
  }

  // FILTER HANDLE CHANGE FUNCTION
  filterTahunAjaran(e) {
    if (e) {
      this.setState(
        {
          tahun_ajaran_search: e.value,
          filterKurikulumSearch: "",
          data_kelas: "",
          data_peminatan: "",
          data_bidang: "",
          data_program: "",
          data_kompetensi: "",
          data_rombel: "",
          // kelas_search: "",
          peminatan_search: "",
          rombel_search: "",
          bidang_search: "",
          program_search: "",
          kompetensi_search: "",
        },
        function () {
          this.setState({ filterKurikulumSearch: "" });
        },
      );
    } else {
      this.setState({
        tahun_ajaran_search: "",
        filterKurikulumSearch: "",
        data_kelas: [],
        data_peminatan: [],
        data_bidang: [],
        data_program: [],
        data_kompetensi: [],
        data_rombel: [],
        kelas_search: "",
        peminatan_search: "",
        rombel_search: "",
        bidang_search: "",
        program_search: "",
        kompetensi_search: "",
      });
    }
  }

  filterKurikulume(e) {
    if (e) {
      this.setState(
        {
          filterKurikulumSearch: e.value,
          data_kelas: [],
          data_peminatan: [],
          data_bidang: [],
          data_program: [],
          data_kompetensi: [],
          data_rombel: [],
          kelas_search: "",
          peminatan_search: "",
          rombel_search: "",
          bidang_search: "",
          program_search: "",
          kompetensi_search: "",
        },
        function () {
          this.getKelas();
        },
      );
    } else {
      this.setState({
        filterKurikulumSearch: null,
        data_kelas: [],
        data_peminatan: [],
        data_bidang: [],
        data_program: [],
        data_kompetensi: [],
        data_rombel: [],
        kelas_search: "",
        peminatan_search: "",
        rombel_search: "",
        bidang_search: "",
        program_search: "",
        kompetensi_search: "",
      });
    }
  }

  filterKelas(e) {
    if (e) {
      this.setState(
        {
          kelas_search: e.value,
          data_peminatan: [],
          data_bidang: [],
          data_program: [],
          data_kompetensi: [],
          data_rombel: [],
          peminatan_search: "",
          rombel_search: "",
          bidang_search: "",
          program_search: "",
          kompetensi_search: "",
        },
        function () {
          if (this.state.jenjang_id_select == "5" ? this.getBidang() : "");
          if (
            this.state.jenjang_id_select == "4" ? this.getPeminatanSMA() : ""
          );
          if (
            this.state.jenjang_id_select == "1" ||
            this.state.jenjang_id_select == "2" ||
            this.state.jenjang_id_select == "3"
              ? this.getRombel()
              : ""
          );
        },
      );
    } else {
      this.setState(
        {
          kelas_search: "",
          data_peminatan: [],
          data_bidang: [],
          data_program: [],
          data_kompetensi: [],
          data_rombel: [],
          peminatan_search: "",
          rombel_search: "",
          bidang_search: "",
          program_search: "",
          kompetensi_search: "",
        },
        function () {
          if (
            this.state.jenjang_id_select == "1" ||
            this.state.jenjang_id_select == "3" ||
            this.state.jenjang_id_select == "2"
              ? this.getRombel()
              : ""
          );
          if (this.state.jenjang_id_select == "5" ? this.getBidang() : "");
        },
      );
    }
  }

  clearValue = () => {
    this.selectRef.select.clearValue();
  };

  filterKelasBaru(e) {
    if (e) {
      this.setState(
        {
          kelas_search: e.value,
          // data_peminatan: "",
          // data_bidang: "",
          // data_program: "",
          // data_kompetensi: "",
          // data_rombel: "",
          // peminatan_search_baru: "",
          // peminatan_search_label_baru: "",
          // rombel_search: "",
          // bidang_search: "",
          // program_search: "",
          // kompetensi_search: "",
        },
        function () {
          this.getRombel(e.value, 0);
        },
      );
    }
  }

  filterPeminatan(e) {
    //Only SMA
    if (e) {
      this.setState(
        {
          // filterPeminatanBaru: e.value,
          peminatan_search: e.value,
          peminatan_search_label: e.label,
          // peminatan_search_baru: e.value,
          // peminatan_search_label_baru: e.label,
          // data_bidang: [],
          // data_program: [],
          // data_kompetensi: [],
          // data_rombel: [],
          // rombel_search: "",
          // bidang_search: "",
          // program_search: "",
          // kompetensi_search: "",
        },
        function () {
          this.getRombel(0, e.value);
        },
      );
      this.getPeminatanSMA;
    } else {
      this.setState({
        peminatan_search: "",
        peminatan_search_label: "",
        data_bidang: [],
        data_program: [],
        data_kompetensi: [],
        data_rombel: [],
        bidang_search: "",
        rombel_search: "",
        program_search: "",
        kompetensi_search: "",
      });
    }
  }

  // only for SMK
  filterBidang(e) {
    if (e) {
      this.setState(
        {
          bidang_search: e.value,
          bidang_search_label: e.label,
          data_program: [],
          data_kompetensi: [],
          data_rombel: [],
          rombel_search: "",
          program_search: "",
          kompetensi_search: "",
        },
        function () {
          this.getProgram();
        },
      );
    } else {
      this.setState({
        bidang_search: "",
        bidang_search_label: "",
        data_program: [],
        data_kompetensi: [],
        data_rombel: [],
        rombel_search: "",
        program_search: "",
        kompetensi_search: "",
      });
    }
  }
  filterProgram(e) {
    if (e) {
      this.setState(
        {
          program_search: e.value,
          program_search_label: e.label,
          data_kompetensi: [],
          data_rombel: [],
          rombel_search: "",
          kompetensi_search: "",
        },
        function () {
          if (this.state.filterKurikulumSearch === "k13") {
            this.getKompetensi();
          }
          if (this.state.filterKurikulumSearch === "merdeka") {
            this.getRombel();
          }
        },
      );
    } else {
      this.setState({
        program_search: "",
        program_search_label: "",
        data_kompetensi: [],
        data_rombel: [],
        rombel_search: "",
        kompetensi_search: "",
      });
    }
  }
  filterKompetensi(e) {
    if (e) {
      this.setState(
        {
          kompetensi_search: e.value,
          kompetensi_search_label: e.label,
          rombel_search: "",
        },
        function () {
          this.getRombel();
        },
      );
    } else {
      this.setState({
        kompetensi_search: "",
        kompetensi_search_label: "",
        rombel_search: "",
      });
    }
  }

  filterRombel(e) {
    if (e) {
      this.setState(
        {
          rombel_search: e.value,
          rombel_search_label: e.label,
        },
        function () {
          this.urutanJenjang();
        },
      );
    } else {
      this.setState(
        {
          rombel_search: "",
          rombel_search_label: "",
        },
        function () {
          this.urutanJenjang();
        },
      );
    }
  }

  // ================= TARGET ROMBEL HANDLERS =================
  handleTargetTahunAjaran(e) {
    this.setState(
      {
        target_tahun_ajaran: e ? e.value : "",
        // Reset child fields
        target_rombel_id: "",
        target_rombel_label: "",
        data_target_rombel: [],
      },
      () => {
        if (this.state.target_kelas && this.state.target_tahun_ajaran) {
          this.fetchTargetRombel();
        }
      },
    );
  }

  handleTargetKurikulum(e) {
    this.setState(
      {
        target_kurikulum: e ? e.value : "",
        // Reset child fields
        target_rombel_id: "",
        target_rombel_label: "",
        data_target_rombel: [],
      },
      () => {
        if (this.state.target_kelas && this.state.target_tahun_ajaran) {
          this.fetchTargetRombel();
        }
      },
    );
  }

  handleTargetKelas(e) {
    this.setState(
      {
        target_kelas: e ? e.value : "",
        // Reset rombel when class changes
        target_rombel_id: "",
        target_rombel_label: "",
        data_target_rombel: [],
      },
      () => {
        this.fetchTargetRombel();
      },
    );
  }

  handleTargetRombel(e) {
    this.setState({
      target_rombel_id: e ? e.value : "",
      target_rombel_label: e ? e.label : "",
    });
  }

  fetchTargetRombel() {
    if (
      !this.state.target_tahun_ajaran ||
      !this.state.target_kelas ||
      !this.state.target_kurikulum
    )
      return;

    this.setState({ loading_target_rombel: true });

    // Use existing user institution ID
    const institutionId = this.state.institusi_id_select;

    axios
      .get(
        `${this.state.url_get_rombel}?tahun_ajaran=${this.state.target_tahun_ajaran}&kelas=${this.state.target_kelas}&user_institusi_id=${institutionId}&kurikulum=${this.state.target_kurikulum}`,
        { headers: { Authorization: tokenApi } },
      )
      .then((res) => {
        this.setState({
          data_target_rombel: res.data,
          loading_target_rombel: false,
        });
      })
      .catch((err) => {
        this.setState({
          data_target_rombel: [],
          loading_target_rombel: false,
        });
      });
  }

  setFilter(e) {
    e.preventDefault();
    // console.log(this.state.peminatan_search, this.state.rombel_search, this.state.rombel_search_label)
    this.setState({ disabledFilter: true });
    this.setState({ loadingSearch: true });
    var kompetensi = "";
    var kompetensi_label = "";
    var program = "";
    var program_label = "";

    if (
      this.state.jenjang_id_select == "5" &&
      this.state.filterKurikulumSearch === "k13"
    ) {
      kompetensi = this.state.kompetensi_search;
      kompetensi_label = this.state.kompetensi_search_label;
    } else if (
      this.state.jenjang_id_select == "5" &&
      this.state.filterKurikulumSearch === "merdeka"
    ) {
      program = this.state.program_search;
      program_label = this.state.program_search_label;
    } else {
      kompetensi = this.state.peminatan_search;
      kompetensi_label = this.state.peminatan_search_label;
    }
    axios
      .put(
        this.state.url_get_filter + "/" + this.state.institusi_id_select,
        {
          tahun_ajaran: this.state.tahun_ajaran_search,
          kelas: this.state.kelas_search,
          bidang: this.state.bidang_search_label,
          bidang_id: this.state.bidang_search,
          program: program_label,
          program_id: program,
          kompetensi: kompetensi_label,
          kompetensi_id: kompetensi,
          rombel_id: this.state.rombel_search,
          rombel: this.state.rombel_search_label,
        },
        { headers: { Authorization: tokenApi } },
      )
      .then((res) => {
        this.setState({ disabledFilter: false });
        this.setState({ loadingSearch: false });
      });

    // Determine m_spektrum based on jenjang and kurikulum
    var m_spektrum = "";
    if (this.state.jenjang_id_select == "5") {
      // SMK
      if (this.state.filterKurikulumSearch === "merdeka") {
        m_spektrum = this.state.program_search;
      } else {
        // K13
        m_spektrum = this.state.kompetensi_search;
      }
    } else {
      // SD/SMP/SMA
      m_spektrum = this.state.peminatan_search;
    }

    let peminatanCuk = m_spektrum ? m_spektrum : this.state.filterPeminatanBaru;

    // Allow search if at least Tahun Ajaran is selected (relaxed validation)
    if (this.state.tahun_ajaran_search) {
      this.setState(
        {
          url_show_data: `${this.state.url}`,
          query:
            "&tahun_ajaran=" +
            this.state.tahun_ajaran_search +
            "&kelas=" +
            this.state.kelas_search +
            "&m_spektrum_id=" +
            peminatanCuk +
            "&user_institusi_id=" +
            this.state.institusi_id_select +
            (this.state.rombel_search
              ? "&filter=true&filter_rombel=" + this.state.rombel_search
              : "") +
            "&kurikulum=" +
            (this.state.filterKurikulumSearch
              ? this.state.filterKurikulumSearch
              : "k13") +
            "&paginate=" +
            this.state.mode_show,
          search: true,
          showDataTable: true,
        },
        function () {
          if (this.dt) {
            this.dt.loading();
            this.dt.resetPage(this.state.query);
          }
          // Save filter history to localStorage
          this.saveFilterHistory();
        },
      );
    } else {
      this.setState({
        show_alert: true,
        title_alert: "Gagal",
        icon_alert: "error",
        message_alert: "Tahun Ajaran wajib diisi",
      });
    }
  }

  setResetFilter(e) {
    e.preventDefault();
    this.setState(
      {
        tahun_ajaran_search: "",
        filterKurikulumSearch: "",
        data_tahun_ajaran: [],
        data_kelas: [],
        data_peminatan: [],
        data_bidang: [],
        data_program: [],
        data_kompetensi: [],
        data_rombel: [],
        kelas_search: "",
        peminatan_search: "",
        peminatan_search_label: "",
        rombel_search: "",
        rombel_search_label: "",
        bidang_search: "",
        bidang_search_label: "",
        program_search: "",
        program_search_label: "",
        kompetensi_search: "",
        kompetensi_search_label: "",
        searchQuery: "",
        disabledFilter: false,
      },
      function () {
        this.getTahunAjaranNow();
        // Clear saved filter history
        this.clearFilterHistory();
        // Reload all data without filter (show all rombel)
        this.loadAllData();
      },
    );
  }

  // ============ SELECTION LOGIC ============
  toggleStudentSelection(student) {
    this.setState((prevState) => {
      const newMap = new Map(prevState.selectedStudents);
      if (newMap.has(student.id)) {
        newMap.delete(student.id);
      } else {
        newMap.set(student.id, student);
      }
      return { selectedStudents: newMap };
    });
  }

  removeFromSelection(studentId) {
    this.setState((prevState) => {
      const newMap = new Map(prevState.selectedStudents);
      newMap.delete(studentId);
      return { selectedStudents: newMap };
    });
  }

  clearAllSelections = () => {
    this.setState({ selectedStudents: new Map() });
  };

  // SEARCH TEXT
  searchText(e) {
    // Optional preventDefault for form events, skip for synthetic objects
    if (e && typeof e.preventDefault === "function") {
      e.preventDefault();
    }

    if (this.state.url_show_data !== "" || this.state.query !== "") {
      var m_spektrum = "";
      if (
        this.state.jenjang_id_select == "5" &&
        this.state.filterKurikulumSearch === "k13"
          ? (m_spektrum = this.state.kompetensi_search)
          : (m_spektrum = this.state.peminatan_search)
      );

      // For select kurikulum merdeka
      if (
        this.state.jenjang_id_select == "5" &&
        this.state.filterKurikulumSearch === "merdeka"
          ? (m_spektrum = this.state.program_search)
          : (m_spektrum = this.state.peminatan_search)
      );

      const searchValue = e?.target?.value || "";

      this.setState(
        {
          query:
            "&has_rombel=true" +
            "&tahun_ajaran=" +
            this.state.tahun_ajaran_search +
            "&kelas=" +
            this.state.kelas_search +
            "&m_spektrum_id=" +
            m_spektrum +
            "&rombel_id=" +
            this.state.rombel_search +
            "&user_institusi_id=" +
            this.state.institusi_id_select +
            "&query=" +
            searchValue +
            "&paginate=" +
            this.state.mode_show,
          searchText: searchValue,
        },
        function () {
          if (this.dt) {
            this.dt.resetPage(this.state.query);
          }
        },
      );
    }
  }

  showData() {
    if (this.state.showDataTable) {
      return (
        <div className="px-1 py-1">
          <DataTable
            ref={(dt) => {
              this.dt = dt;
            }}
            action={{
              no: (col, data, index) => {
                const page =
                  this.dt?.state?.entities?.current_page ||
                  this.dt?.state?.current_page ||
                  1;
                const perPage =
                  this.dt?.state?.entities?.per_page ||
                  this.state.mode_show ||
                  10;
                return (page - 1) * perPage + index + 1;
              },
              pilih: (col, data) => {
                // Check if student is already assigned to a target
                const assignedTarget = Object.entries(
                  this.state.assignedStudents,
                ).find(([tid, students]) =>
                  students.some((s) => s.id === data.id),
                );

                if (assignedTarget) {
                  const targetInfo = this.state.preparedTargets.find(
                    (t) => t.id === assignedTarget[0],
                  );
                  return (
                    <span className="inline-flex items-center px-2 py-1 bg-emerald-100 text-emerald-700 text-xs rounded-lg font-medium">
                      <i className="bx bx-check-circle mr-1"></i>
                      {targetInfo?.label || "Assigned"}
                    </span>
                  );
                }

                return (
                  <label className="inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      className="select-checkbox sr-only peer"
                      checked={this.state.selectedStudents.has(data.id)}
                      onChange={() => this.toggleStudentSelection(data)}
                    />
                    <div className="w-6 h-6 rounded-lg border-2 border-gray-300 peer-checked:border-indigo-500 peer-checked:bg-indigo-500 flex items-center justify-center transition-all">
                      <i
                        className={`bx bx-check text-white ${this.state.selectedStudents.has(data.id) ? "opacity-100" : "opacity-0"} transition-opacity`}
                      ></i>
                    </div>
                  </label>
                );
              },
              jenis_kelamin: (col, data) => {
                const rawVal = data.jenis_kelamin;
                const val = (
                  rawVal !== null && rawVal !== undefined ? String(rawVal) : ""
                )
                  .toUpperCase()
                  .trim();

                const isMale =
                  val === "1" ||
                  val === "L" ||
                  val === "M" ||
                  val === "LAKI-LAKI" ||
                  val === "LAKI - LAKI" ||
                  val === "MALE";
                const isFemale =
                  val === "0" ||
                  val === "P" ||
                  val === "F" ||
                  val === "PEREMPUAN" ||
                  val === "FEMALE";

                let label = isMale ? "L" : isFemale ? "P" : "-";
                let color = isMale
                  ? "bg-blue-100 text-blue-700"
                  : isFemale
                    ? "bg-pink-100 text-pink-700"
                    : "bg-gray-100 text-gray-700";

                return (
                  <span
                    className={`px-2 py-1 rounded-full text-xs font-medium ${color}`}
                  >
                    {label}
                  </span>
                );
              },
              tanggal_lahir: (col, data) => {
                if (!data.tanggal_lahir) return "-";
                const date = new Date(data.tanggal_lahir);
                return date.toLocaleDateString("id-ID", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                });
              },
              status: (col, data) => {
                const val = String(data.status || "")
                  .toLowerCase()
                  .trim();
                const isActive =
                  val === "aktif" ||
                  val === "active" ||
                  val === "1" ||
                  val === "true";
                const isNonActive =
                  val === "non-aktif" ||
                  val === "non-active" ||
                  val === "inactive" ||
                  val === "0" ||
                  val === "false";

                let label = isActive
                  ? "Aktif"
                  : isNonActive
                    ? "Non-Aktif"
                    : data.status || "Pending";
                let color = isActive
                  ? "bg-green-100 text-green-700"
                  : isNonActive
                    ? "bg-red-100 text-red-700"
                    : "bg-yellow-100 text-yellow-700";

                return (
                  <span
                    className={`px-2 py-1 rounded-full text-xs font-medium ${color}`}
                  >
                    {label}
                  </span>
                );
              },
              nama_rombel: (col, data) => {
                if (!data.nama_rombel)
                  return <span className="text-gray-400 text-xs">-</span>;
                return (
                  <span className="px-2 py-1 rounded-lg bg-indigo-50 text-indigo-700 text-xs font-medium border border-indigo-200">
                    {data.nama_rombel}
                  </span>
                );
              },
            }}
            url={this.state.url}
            columns={[
              { index: "no", label: "No" },
              { index: "kode_pendaftaran", label: "Kode Pendaftaran" },
              { index: "nama", label: "Nama Lengkap" },
              { index: "nama_rombel", label: "Rombel Sekarang" },
              { index: "jenis_kelamin", label: "JK" },
              { index: "tanggal_lahir", label: "Tgl Lahir" },
              { index: "status", label: "Status" },
              { index: "pilih", label: "Pilih" },
            ]}
          />
        </div>
      );
    } else {
      return (
        <div className="w-full text-center">
          <p className="text-sm">Select Filter terlebih dahulu</p>
        </div>
      );
    }
  }

  naikKelas(e, targetRombelId, targetTahunAjaran) {
    if (e) e.preventDefault();
    this.setState({ loading_naik: true });

    const studentIds = Array.from(this.state.selectedStudents.keys());

    if (studentIds.length == 0) {
      this.setState({
        show_alert: true,
        title_alert: "Gagal",
        icon_alert: "warning",
        message_alert: "Mohon pilih minimal satu siswa terlebih dahulu",
        disabledFilter: false,
        loading_naik: false,
      });
    } else {
      axios
        .post(
          this.state.url_naik_kelas,
          {
            siswa_id: studentIds, // Array of student IDs
            rombel_id: targetRombelId, // Use dynamic TARGET rombel ID
            tahun_ajaran: targetTahunAjaran, // Use dynamic TARGET academic year
            created_by: this.state.institusi_id_select,
          },
          { headers: { Authorization: tokenApi } },
        )
        .then((res) => {
          this.setState({
            loading_naik: false,
            showResultModal: true,
            showTargetSelectionModal: false, // Close selection modal
            resultData: {
              success: res.data.status,
              messages: res.data.messages,
              total: studentIds.length,
            },
            selectedStudents: new Map(), // Clear selection
            checkAll: false, // Uncheck global check
          });
          // Refresh table data
          if (this.dt) {
            this.dt.fetchEntities(this.state.query);
          }
        })
        .catch((err) => {
          const errorMessage =
            err.response && err.response.data && err.response.data.message
              ? err.response.data.message
              : "Terjadi kesalahan";
          this.setState({
            loading_naik: false,
            show_alert: true,
            title_alert: "Gagal",
            icon_alert: "error",
            message_alert: errorMessage,
          });
        });
    }
  }

  handleSubmit = () => {
    // Check if there are any assigned students
    const totalAssigned = this.getTotalAssignedCount();

    if (totalAssigned === 0) {
      setTimeout(() => {
        this.setState({
          show_alert: true,
          title_alert: "Peringatan",
          icon_alert: "warning",
          message_alert:
            "Belum ada siswa yang di-assign ke rombel tujuan. Klik target card untuk assign siswa.",
        });
      }, 0);
      return;
    }

    // Check if targets prepared
    if (this.state.preparedTargets.length === 0) {
      setTimeout(() => {
        this.setState({
          show_alert: true,
          title_alert: "Peringatan",
          icon_alert: "warning",
          message_alert: "Siapkan minimal satu tujuan terlebih dahulu.",
        });
      }, 0);
      return;
    }

    // Show confirmation modal
    this.setState({ showConfirmModal: true });
  };

  // Process all assigned students to their respective target rombels
  processKenaikan = async () => {
    this.setState({ loading_submit: true, showConfirmModal: false });

    const results = [];
    const targets = Object.entries(this.state.assignedStudents);

    for (const [targetId, students] of targets) {
      if (students.length === 0) continue;

      // Use String() for consistent comparison since Object keys are strings
      const targetInfo = this.state.preparedTargets.find(
        (t) => String(t.id) === String(targetId),
      );

      if (!targetInfo) {
        // Target not found - add to failed results
        results.push({
          target: `ID: ${targetId}`,
          count: students.length,
          success: false,
          message: "Target rombel tidak ditemukan",
        });
        continue;
      }

      try {
        const response = await axios.post(
          this.state.url_naik_kelas,
          {
            siswa_id: students.map((s) => s.id),
            rombel_id: targetId,
            tahun_ajaran: targetInfo.tahun_ajaran,
            created_by: this.state.institusi_id_select,
          },
          { headers: { Authorization: tokenApi } },
        );

        results.push({
          target: targetInfo.label,
          count: students.length,
          success: response.data.status !== false,
          message: response.data.messages || "Berhasil",
        });
      } catch (err) {
        results.push({
          target: targetInfo.label,
          count: students.length,
          success: false,
          message: err.response?.data?.message || "Terjadi kesalahan",
        });
      }
    }

    // Show results
    this.setState({
      loading_submit: false,
      showResultModal: true,
      resultData: {
        results: results,
        totalSuccess: results
          .filter((r) => r.success)
          .reduce((sum, r) => sum + r.count, 0),
        totalFailed: results
          .filter((r) => !r.success)
          .reduce((sum, r) => sum + r.count, 0),
      },
      // Clear assignments on success
      assignedStudents: {},
      preparedTargets: [],
      selectedStudents: new Map(),
    });

    // Refresh table data
    if (this.dt) {
      this.dt.fetchEntities(this.state.query);
    }
  };
  renderTargetSelectionModal() {
    if (!this.state.showTargetSelectionModal) return null;

    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 animateFadeIn">
        <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg mx-4 overflow-hidden transform transition-all scale-100">
          <div className="bg-indigo-600 px-6 py-4 flex items-center justify-between">
            <h3 className="text-white font-bold text-lg flex items-center">
              <i className="bx bx-list-ul mr-2"></i> Pilih Tujuan
            </h3>
            <button
              onClick={() => this.setState({ showTargetSelectionModal: false })}
              className="text-white hover:bg-indigo-700 rounded-full w-8 h-8 flex items-center justify-center transition-colors"
            >
              <i className="bx bx-x text-xl"></i>
            </button>
          </div>

          <div className="p-6">
            <p className="text-gray-600 mb-4 text-sm">
              Anda akan memproses{" "}
              <b>{this.state.selectedStudents.size} siswa</b>. Silakan pilih
              kelas tujuan:
            </p>

            <div className="space-y-3 max-h-[60vh] overflow-y-auto pr-1">
              {this.state.preparedTargets.map((target) => (
                <div
                  key={target.id}
                  className="border border-gray-200 rounded-xl p-4 hover:border-indigo-300 hover:shadow-md transition-all cursor-pointer group"
                  onClick={(e) =>
                    this.naikKelas(e, target.id, target.tahun_ajaran)
                  }
                >
                  <div className="flex items-center justify-between">
                    <div>
                      <h4 className="font-bold text-gray-800 group-hover:text-indigo-600 transition-colors">
                        {target.label}
                      </h4>
                      <p className="text-sm text-gray-500">
                        {target.kelas} • {target.tahun_ajaran}
                      </p>
                      <span className="inline-block mt-1 px-2 py-0.5 bg-gray-100 text-gray-600 text-xs rounded-md">
                        {target.kurikulum
                          ? target.kurikulum.toUpperCase()
                          : "-"}
                      </span>
                    </div>
                    <div className="w-10 h-10 rounded-full bg-gray-50 group-hover:bg-indigo-50 flex items-center justify-center transition-colors">
                      <i className="bx bx-chevron-right text-gray-400 group-hover:text-indigo-600 text-2xl"></i>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="px-6 py-4 bg-gray-50 border-t border-gray-100 flex justify-end">
            <button
              onClick={() => this.setState({ showTargetSelectionModal: false })}
              className="px-4 py-2 text-gray-500 hover:text-gray-700 font-medium text-sm transition-colors"
            >
              Batal
            </button>
          </div>
        </div>
      </div>
    );
  }

  renderConfirmModal() {
    if (!this.state.showConfirmModal) return null;

    const totalAssigned = this.getTotalAssignedCount();
    const targetCount = Object.keys(this.state.assignedStudents).filter(
      (k) => (this.state.assignedStudents[k] || []).length > 0,
    ).length;

    return (
      <div className="absolute inset-0 z-50 flex items-center justify-center bg-black/50 rounded-2xl">
        <div className="bg-white rounded-2xl w-full max-w-md mx-4 overflow-hidden shadow-2xl">
          <div className="confirm-modal-header">
            <h3 className="text-white font-bold text-lg flex items-center">
              <i className="bx bx-check-shield mr-2"></i> Konfirmasi Proses
            </h3>
          </div>

          <div className="p-6">
            <div className="text-center mb-6">
              <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-indigo-100 flex items-center justify-center">
                <i className="bx bx-transfer text-3xl text-indigo-600"></i>
              </div>
              <p className="text-gray-700">
                Anda akan memproses{" "}
                <b className="text-indigo-600">{totalAssigned} siswa</b> ke{" "}
                <b className="text-indigo-600">{targetCount} rombel</b> tujuan.
              </p>
            </div>

            {/* Summary per target */}
            <div className="bg-gray-50 rounded-xl p-4 mb-6 max-h-48 overflow-y-auto">
              {Object.entries(this.state.assignedStudents).map(
                ([targetId, students]) => {
                  if (!students || students.length === 0) return null;
                  // Use String() for consistent comparison since Object keys are strings
                  const target = this.state.preparedTargets.find(
                    (t) => String(t.id) === String(targetId),
                  );
                  return (
                    <div
                      key={targetId}
                      className="flex justify-between items-center py-2 border-b border-gray-100 last:border-0"
                    >
                      <span className="text-sm text-gray-700">
                        {target?.label || "Unknown"}
                      </span>
                      <span className="text-sm font-semibold text-indigo-600">
                        {students.length} siswa
                      </span>
                    </div>
                  );
                },
              )}
            </div>

            <div className="flex gap-3">
              <button
                onClick={() => this.setState({ showConfirmModal: false })}
                className="flex-1 px-4 py-2.5 border border-gray-300 text-gray-700 rounded-xl hover:bg-gray-50 transition-all font-medium"
              >
                Batal
              </button>
              <button
                onClick={this.processKenaikan}
                disabled={this.state.loading_submit}
                className="flex-1 px-4 py-2.5 btn-gradient-indigo text-white rounded-xl hover:shadow-lg transition-all font-medium flex items-center justify-center"
              >
                {this.state.loading_submit ? (
                  <>
                    <i className="bx bx-loader-alt animate-spin mr-2"></i>{" "}
                    Memproses...
                  </>
                ) : (
                  <>
                    <i className="bx bx-check mr-2"></i> Ya, Proses
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderResultModal() {
    const { resultData } = this.state;
    if (!resultData) return null;

    // Support both old format (single result) and new format (batch results)
    const isBatch = resultData.results && Array.isArray(resultData.results);
    const isSuccess = isBatch
      ? resultData.totalFailed === 0
      : resultData.success;

    return (
      <Modal
        show={this.state.showResultModal}
        onHide={() =>
          this.setState({ showResultModal: false, resultData: null })
        }
        centered
      >
        <div className="p-6 text-center">
          <div
            className={`w-20 h-20 mx-auto rounded-full ${isSuccess ? "bg-green-100" : "bg-yellow-100"} flex items-center justify-center mb-4`}
          >
            <i
              className={`bx ${isSuccess ? "bx-check-circle text-green-500" : "bx-error text-yellow-500"} text-5xl`}
            ></i>
          </div>

          <h3 className="text-xl font-bold text-gray-800 mb-2">
            {isSuccess ? "Berhasil!" : "Proses Selesai"}
          </h3>

          {isBatch ? (
            <>
              <div className="flex justify-center gap-4 mb-4">
                <div className="px-4 py-3 bg-green-50 rounded-xl text-center">
                  <p className="text-2xl font-bold text-green-600">
                    {resultData.totalSuccess}
                  </p>
                  <p className="text-xs text-green-700">Berhasil</p>
                </div>
                {resultData.totalFailed > 0 && (
                  <div className="px-4 py-3 bg-red-50 rounded-xl text-center">
                    <p className="text-2xl font-bold text-red-600">
                      {resultData.totalFailed}
                    </p>
                    <p className="text-xs text-red-700">Gagal</p>
                  </div>
                )}
              </div>

              <div className="bg-gray-50 rounded-xl p-3 mb-4 max-h-40 overflow-y-auto text-left">
                {resultData.results.map((r, idx) => (
                  <div
                    key={idx}
                    className="flex items-center justify-between py-1.5 text-sm border-b border-gray-100 last:border-0"
                  >
                    <span className="text-gray-700">{r.target}</span>
                    <span
                      className={`font-medium ${r.success ? "text-green-600" : "text-red-600"}`}
                    >
                      {r.success ? `✓ ${r.count} siswa` : `✗ ${r.message}`}
                    </span>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <div className="mb-6">
              {Array.isArray(resultData.messages) ? (
                resultData.messages.map((msg, idx) => (
                  <p key={idx} className="text-gray-600">
                    {msg}
                  </p>
                ))
              ) : (
                <p className="text-gray-600">{resultData.messages}</p>
              )}
            </div>
          )}

          <button
            className="px-8 py-2 rounded-xl btn-gradient-indigo font-medium hover:shadow-lg transition-all"
            onClick={() =>
              this.setState({ showResultModal: false, resultData: null })
            }
          >
            Tutup
          </button>
        </div>
      </Modal>
    );
  }

  tambahAlumni(e) {
    e.preventDefault();
    this.setState({ loading_alumni: true });
    var checkboxes = document.getElementsByName("check_data[]");
    var vals = [];
    for (var i = 0, n = checkboxes.length; i < n; i++) {
      if (checkboxes[i].checked) {
        vals.push(checkboxes[i].value);
      }
    }

    if (vals.length == 0) {
      this.setState({
        show_alert: true,
        title_alert: "Gagal",
        icon_alert: "warning",
        message_alert: "Mohon centang data terlebih dahulu",
        disabledFilter: false,
        loading_alumni: false,
      });
    } else {
      axios
        .post(
          this.state.url_tambah_alumni,
          {
            siswa_id: vals,
            updated_by: this.state.institusi_id_select,
          },
          { headers: { Authorization: tokenApi } },
        )
        .then((res) => {
          // let pesan = res.data.messages.key;
          this.setState({ loading_alumni: false });
          if (res.data.status == false) {
            this.setState({
              show_alert: true,
              title_alert: "Gagal",
              icon_alert: "error",
              message_alert: res.data.messages[0],
              loading_alumni: false,
            });
            this.dt.fetchEntities(this.state.query);
          } else {
            this.setState({
              show_alert: true,
              title_alert: "Berhasil",
              icon_alert: "success",
              message_alert: res.data.messages,
              loading_alumni: false,
            });
            this.dt.fetchEntities(this.state.query);
          }
        })
        .catch((err) => {
          this.setState({ loading_alumni: false });
          this.alertMessage(err.response);
        });
    }
  }

  selectAll(e) {
    let itemName = e.target.name;
    let itemVal = e.target.value;
    let itemId = e.target.id;
    let checkall = e.target.checked;
    if (itemName === "check_semua") {
      document.getElementsByName("check_semua").checked = true;
      this.setState({ check_all: checkall });
    }
  }
  selectOne(e) {
    let itemName = e.target.name;
    let itemVal = e.target.value;
    let itemId = e.target.id;
    let itemCheck = e.target.checked;
    if (this.state.check_all == true) {
      {
        itemId == itemVal
          ? this.setState({ check_id: itemId })
          : null ||
              document.getElementsByClassName(".select-checkbox").checked !=
                true
            ? this.setState({ check_item: true })
            : this.setState({ check_item: false });
      }
      // { document.getElementsByClassName('.select-checkbox').checked == false ? this.setState({check_item: true}) : this.setState({check_item: false}) }
      // if(itemId == itemVal){
      //   this.setState({check_id: itemId})
      // }
    }
  }

  checkAll(e) {
    e.preventDefault();
    var check = document.getElementsByName("check_data[]");
    this.setState({ checkAll: true });

    if (check.length != 0) {
      for (var i = 0; i < check.length; i++) {
        check[i].checked = true;
      }
    }
  }

  unCheckAll(e) {
    e.preventDefault();
    var check = document.getElementsByName("check_data[]");
    this.setState({ checkAll: false });

    if (check.length != 0) {
      for (var i = 0; i < check.length; i++) {
        check[i].checked = false;
      }
    }
  }

  filterBidangBaru(e) {
    if (e) {
      this.setState(
        {
          bidang_search: e.value,
          bidang_search_label: e.label,
          // data_program: "",
          // data_kompetensi: "",
          // data_rombel: "",
          // rombel_search: "",
          // program_search: "",
          // kompetensi_search: "",
        },
        function () {
          this.getProgramBaru();
        },
      );
    } else {
      this.setState({
        bidang_search: "",
        bidang_search_label: "",
        // data_program: "",
        // data_kompetensi: "",
        // data_rombel: "",
        // rombel_search: "",
        // program_search: "",
        // kompetensi_search: "",
      });
    }
  }
  filterProgramBaru(e) {
    if (e) {
      this.setState(
        {
          program_search: e.value,
          program_search_label: e.label,
          // data_kompetensi: "",
          // data_rombel: "",
          // rombel_search: "",
          // kompetensi_search: "",
        },
        function () {
          this.getKompetensiBaru();
        },
      );
    } else {
      this.setState({
        program_search: "",
        program_search_label: "",
        // data_kompetensi: "",
        // data_rombel: "",
        // rombel_search: "",
        // kompetensi_search: "",
      });
    }
  }
  filterKompetensiBaru(e) {
    if (e) {
      this.setState(
        {
          kompetensi_search: e.value,
          kompetensi_search_label: e.label,
          // rombel_search: "",
        },
        function () {
          this.getRombel(0, e.value);
        },
      );
    } else {
      this.setState({
        kompetensi_search: "",
        kompetensi_search_label: "",
        // rombel_search: "",
      });
    }
  }

  filterPeminatanShow() {
    if (this.state.jenjang_id_select == 4) {
      return (
        <div className="flex w-1/5">
          <div className="py-2 mr-2">
            <Select
              styles={selectStyles}
              // isClearable={true}
              isLoading={this.state.loading_peminatan ? true : false}
              defaultValue={
                this.state.peminatan_search_baru != ""
                  ? {
                      value: this.state.peminatan_search_baru,
                      label: this.state.peminatan_search_label_baru,
                    }
                  : ""
              }
              onChange={(e) => {
                if (!isEmpty(e)) {
                  // this.setState({
                  //   filterPeminatan: e.value,
                  // });
                  this.selectReff.select.clearValue();
                  this.filterPeminatan(e);
                }
              }}
              ref={(ref) => {
                this.selectRef = ref;
              }}
              options={this.state.data_peminatan}
              placeholder={
                this.state.data_peminatan == ""
                  ? "Peminatan Kosong"
                  : "Pilih Peminatan"
              }
            />
          </div>
        </div>
      );
    } else if (
      this.state.jenjang_id_select == "5" &&
      this.state.filterKurikulumSearch === "k13"
    ) {
      return (
        <>
          {this.state.kelas_search != "" ? (
            <>
              <div className="py-2 ml-2">
                <Select
                  id="filterBidang"
                  styles={selectStyles}
                  isClearable={true}
                  defaultValue={
                    this.state.bidang_search_baru != ""
                      ? {
                          value: this.state.bidang_search_baru,
                          label: this.state.bidang_search_label_baru,
                        }
                      : ""
                  }
                  isLoading={this.state.loading_bidang ? true : false}
                  options={this.state.data_bidang}
                  onChange={this.filterBidangBaru}
                  // className="animateFadeInLeft"
                  placeholder={
                    this.state.loading_bidang ? "Loading" : "Bidang Keahlian"
                  }
                />
              </div>
            </>
          ) : (
            <></>
          )}
          {this.state.bidang_search != "" ? (
            <>
              <div className="py-2 ml-2">
                <Select
                  id="filterProgram"
                  styles={selectStyles}
                  isClearable={true}
                  defaultValue={
                    this.state.program_search_baru != ""
                      ? {
                          value: this.state.program_search_baru,
                          label: this.state.program_search_label_baru,
                        }
                      : ""
                  }
                  isLoading={this.state.loading_program ? true : false}
                  options={this.state.data_program}
                  onChange={this.filterProgramBaru}
                  placeholder={
                    this.state.loading_program ? "Loading" : "Program Keahlian"
                  }
                />
              </div>
            </>
          ) : (
            <></>
          )}
          {this.state.program_search != "" ? (
            <>
              <div className="py-2 ml-2">
                <Select
                  id="filterKompetensi"
                  styles={selectStyles}
                  isClearable={true}
                  defaultValue={
                    this.state.kompetensi_search_baru != ""
                      ? {
                          value: this.state.kompetensi_search_baru,
                          label: this.state.kompetensi_search_label_baru,
                        }
                      : ""
                  }
                  isLoading={this.state.loading_kompetensi ? true : false}
                  options={this.state.data_kompetensi}
                  onChange={this.filterKompetensiBaru}
                  placeholder={
                    this.state.loading_kompetensi
                      ? "Loading"
                      : "Kompetensi Keahlian"
                  }
                />
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      );
    } else if (
      this.state.jenjang_id_select == "5" &&
      this.state.filterKurikulumSearch === "merdeka"
    ) {
      return (
        <>
          {this.state.kelas_search != "" ? (
            <>
              <div className="py-2 ml-2">
                <Select
                  id="filterBidang"
                  styles={selectStyles}
                  isClearable={true}
                  defaultValue={
                    this.state.bidang_search_baru != ""
                      ? {
                          value: this.state.bidang_search_baru,
                          label: this.state.bidang_search_label_baru,
                        }
                      : ""
                  }
                  isLoading={this.state.loading_bidang ? true : false}
                  options={this.state.data_bidang}
                  onChange={this.filterBidangBaru}
                  // className="animateFadeInLeft"
                  placeholder={
                    this.state.loading_bidang ? "Loading" : "Bidang Keahlian"
                  }
                />
              </div>
            </>
          ) : (
            <></>
          )}
          {this.state.bidang_search != "" ? (
            <>
              <div className="py-2 ml-2">
                <Select
                  id="filterProgram"
                  styles={selectStyles}
                  isClearable={true}
                  defaultValue={
                    this.state.program_search_baru != ""
                      ? {
                          value: this.state.program_search_baru,
                          label: this.state.program_search_label_baru,
                        }
                      : ""
                  }
                  isLoading={this.state.loading_program ? true : false}
                  options={this.state.data_program}
                  onChange={this.filterProgramBaru}
                  placeholder={
                    this.state.loading_program ? "Loading" : "Program Keahlian"
                  }
                />
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      );
    }
  }

  formFilter() {
    return (
      <>
        {this.state.jenjang_id_select == "5" ? (
          <>
            <div class="flex flex-wrap">
              <div className="flex w-1/5">
                <div className="py-2 mr-2">
                  <Select
                    styles={selectStyles}
                    isDisabled={this.state.disabledFilter}
                    defaultValue={
                      this.state.tahun_ajaran_search != null
                        ? {
                            value: this.state.tahun_ajaran_search,
                            label: this.state.tahun_ajaran_search,
                          }
                        : ""
                    }
                    onChange={(e) => {
                      if (!isEmpty(e)) {
                        this.setState({
                          filterTahunAjaran: e.value,
                        });
                      }
                    }}
                    options={this.state.data_tahun_ajaran}
                    placeholder={"Pilih Tahun Ajaran"}
                  />
                </div>
              </div>

              <div className="flex w-1/5">
                <div className="py-2 mr-2">
                  <Select
                    styles={selectStyles}
                    isDisabled={this.state.disabledFilter}
                    onChange={(e) => {
                      if (!isEmpty(e)) {
                        this.setState({
                          filterKurikulumBaru: e.value,
                        });
                      }
                    }}
                    options={dataKurikulum}
                    placeholder={"Pilih Kurikulum"}
                  />
                </div>
              </div>

              <div className="flex w-1/5">
                <div className="py-2 mr-2">
                  <Select
                    styles={selectStyles}
                    options={this.state.data_kelas}
                    placeholder={"Pilih Kelas"}
                    onChange={(e) => {
                      if (!isEmpty(e)) {
                        if (this.state.jenjang_id_select == 4) {
                          this.selectRef.select.clearValue();
                        }
                        this.filterKelasBaru(e);
                      }
                    }}
                  />
                </div>
              </div>

              {this.filterPeminatanShow()}

              <div className="flex w-1/5">
                <div className="py-2 mr-2">
                  <Select
                    styles={selectStyles}
                    isClearable={true}
                    isLoading={this.state.loading_rombel_baru ? true : false}
                    defaultValue={
                      this.state.rombel_search != ""
                        ? {
                            value: this.state.rombel_search,
                            label: this.state.rombel_search_label,
                          }
                        : ""
                    }
                    options={this.state.data_rombel}
                    onChange={(e) => {
                      if (!isEmpty(e)) {
                        this.setState({
                          filterRombel: e.value,
                        });
                      }
                    }}
                    ref={(ref) => {
                      this.selectReff = ref;
                    }}
                    placeholder={
                      this.state.data_rombel == ""
                        ? "Rombel Kosong"
                        : "Pilih Rombel"
                    }
                  />
                </div>
              </div>

              <button
                className="btn-blue px-4 py-2 mr-1 flex items-center rounded-full text-white text-xs"
                onClick={() => this.clickFilter()}
              >
                <i className="bx bx-filter text-lg mr-1"></i>
                Filter
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="flex w-1/5">
              <div className="py-2 mr-2">
                <Select
                  styles={selectStyles}
                  isDisabled={this.state.disabledFilter}
                  defaultValue={
                    this.state.tahun_ajaran_search != null
                      ? {
                          value: this.state.tahun_ajaran_search,
                          label: this.state.tahun_ajaran_search,
                        }
                      : ""
                  }
                  onChange={(e) => {
                    if (!isEmpty(e)) {
                      this.setState({
                        filterTahunAjaran: e.value,
                      });
                    }
                  }}
                  options={this.state.data_tahun_ajaran}
                  placeholder={"Pilih Tahun Ajaran"}
                />
              </div>
            </div>

            <div className="flex w-1/5">
              <div className="py-2 mr-2">
                <Select
                  styles={selectStyles}
                  isDisabled={this.state.disabledFilter}
                  onChange={(e) => {
                    if (!isEmpty(e)) {
                      this.setState({
                        filterKurikulumBaru: e.value,
                      });
                    }
                  }}
                  options={dataKurikulum}
                  placeholder={"Pilih Kurikulum"}
                />
              </div>
            </div>

            <div className="flex w-1/5">
              <div className="py-2 mr-2">
                <Select
                  styles={selectStyles}
                  // isClearable={true}
                  options={this.state.data_kelas}
                  // defaultValue={
                  //   this.state.kelas_search != ""
                  //     ? {
                  //         value: this.state.kelas_search,
                  //         label: this.state.kelas_search,
                  //       }
                  //     : ""
                  // }
                  placeholder={"Pilih Kelas"}
                  onChange={(e) => {
                    if (!isEmpty(e)) {
                      // this.setState({
                      //   filterKelas: e.value,
                      // });
                      if (this.state.jenjang_id_select == 4) {
                        this.selectRef.select.clearValue();
                      }
                      this.filterKelasBaru(e);
                    }
                  }}
                />
              </div>
            </div>

            {this.filterPeminatanShow()}

            <div className="flex w-1/5">
              <div className="py-2 mr-2">
                <Select
                  styles={selectStyles}
                  isClearable={true}
                  isLoading={this.state.loading_rombel_baru ? true : false}
                  defaultValue={
                    this.state.rombel_search != ""
                      ? {
                          value: this.state.rombel_search,
                          label: this.state.rombel_search_label,
                        }
                      : ""
                  }
                  options={this.state.data_rombel}
                  onChange={(e) => {
                    if (!isEmpty(e)) {
                      this.setState({
                        filterRombel: e.value,
                      });
                    }
                  }}
                  ref={(ref) => {
                    this.selectReff = ref;
                  }}
                  placeholder={
                    this.state.data_rombel == ""
                      ? "Rombel Kosong"
                      : "Pilih Rombel"
                  }
                />
              </div>
            </div>
            <button
              className="btn-blue px-4 py-2 mr-1 flex items-center rounded-full text-white text-xs"
              onClick={() => this.clickFilter()}
            >
              <i className="bx bx-filter text-lg mr-1"></i>
              Filter
            </button>
          </>
        )}
      </>
    );
  }

  clickFilter() {
    // console.log(this.state.filterKurikulumBaru)
    this.setState({ disabledFilter: true });
    this.setState({ loadingSearch: true });
    var kompetensi = "";
    var kompetensi_label = "";

    var m_spektrum = "";
    if (
      this.state.jenjang_id_select == "5" &&
      this.state.filterKurikulumSearch === "k13"
        ? (m_spektrum = this.state.kompetensi_search)
        : (m_spektrum = this.state.peminatan_search)
    );

    // For select kurikulum merdeka
    if (
      this.state.jenjang_id_select == "5" &&
      this.state.filterKurikulumSearch === "merdeka"
        ? (m_spektrum = this.state.program_search)
        : (m_spektrum = this.state.peminatan_search)
    );

    if (this.state.rombel_search !== "") {
      let filterKurikulum = this.state.filterKurikulumBaru
        ? this.state.filterKurikulumBaru
        : "k13";
      this.setState(
        {
          url_show_data: `${this.state.url}`,
          query:
            "&tahun_ajaran=" +
            this.state.filterTahunAjaran +
            "&kelas=" +
            this.state.filterKelas +
            "&m_spektrum_id=" +
            this.state.filterPeminatanBaru +
            "&user_institusi_id=" +
            this.state.institusi_id_select +
            "&paginate=" +
            this.state.mode_show +
            "&filter=true" +
            "&filter_rombel=" +
            this.state.filterRombel +
            "&kurikulum=" +
            filterKurikulum,
          search: true,
        },
        function () {
          if (
            this.state.filterTahunAjaran == null ||
            this.state.filterTahunAjaran == ""
          ) {
            this.setState({ disabledFilter: false });
            this.setState({ loadingSearch: false });
            this.setState({
              search: false,
              show_alert: true,
              title_alert: "Gagal",
              icon_alert: "error",
              message_alert: "Tahun Ajaran wajib diisi",
            });
          } else {
            this.dt.loading();
            this.dt.resetPage(this.state.query);
          }
        },
      );
    }
  }

  renderSMKFilters() {
    return (
      <>
        {/* Bidang */}
        <div className="filter-group">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-indigo-100 text-indigo-600 text-xs font-bold mr-2">
              4a
            </span>
            Bidang Keahlian
          </label>
          <Select
            styles={selectStyles}
            options={this.state.data_bidang}
            value={
              this.state.bidang_search
                ? {
                    value: this.state.bidang_search,
                    label:
                      this.state.bidang_search_label ||
                      this.state.bidang_search,
                  }
                : null
            }
            onChange={this.filterBidang}
            placeholder={
              this.state.kelas_search ? "Pilih Bidang" : "Pilih Kelas dulu"
            }
            isLoading={this.state.loading_bidang}
            isClearable
            isDisabled={!this.state.kelas_search}
          />
        </div>

        {/* Program */}
        {this.state.bidang_search && (
          <div className="filter-group">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-indigo-100 text-indigo-600 text-xs font-bold mr-2">
                4b
              </span>
              Program Keahlian
            </label>
            <Select
              styles={selectStyles}
              options={this.state.data_program}
              value={
                this.state.program_search
                  ? {
                      value: this.state.program_search,
                      label:
                        this.state.program_search_label ||
                        this.state.program_search,
                    }
                  : null
              }
              onChange={this.filterProgram}
              placeholder="Pilih Program"
              isLoading={this.state.loading_program}
              isClearable
            />
          </div>
        )}

        {/* Kompetensi - only for K13 */}
        {this.state.program_search &&
          this.state.filterKurikulumSearch === "k13" && (
            <div className="filter-group">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-indigo-100 text-indigo-600 text-xs font-bold mr-2">
                  4c
                </span>
                Kompetensi Keahlian
              </label>
              <Select
                styles={selectStyles}
                options={this.state.data_kompetensi}
                value={
                  this.state.kompetensi_search
                    ? {
                        value: this.state.kompetensi_search,
                        label:
                          this.state.kompetensi_search_label ||
                          this.state.kompetensi_search,
                      }
                    : null
                }
                onChange={this.filterKompetensi}
                placeholder="Pilih Kompetensi"
                isLoading={this.state.loading_kompetensi}
                isClearable
              />
            </div>
          )}
      </>
    );
  }

  renderFilterPanel() {
    return (
      <div className="glass-card p-6 mb-6">
        <div className="flex items-center mb-6">
          <div className="w-10 h-10 rounded-xl icon-gradient-indigo-violet flex items-center justify-center mr-3">
            <i className="bx bx-filter-alt text-white text-xl"></i>
          </div>
          <div>
            <h2 className="text-lg font-bold text-gray-800">
              Filter Data Siswa (Asal)
            </h2>
            <p className="text-sm text-gray-500">
              Cari siswa berdasarkan rombel saat ini
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {/* Tahun Ajaran */}
          <div className="filter-group">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-indigo-100 text-indigo-600 text-xs font-bold mr-2">
                1
              </span>
              Tahun Ajaran
            </label>
            <Select
              styles={selectStyles}
              options={this.state.data_tahun_ajaran}
              value={
                this.state.tahun_ajaran_search
                  ? {
                      value: this.state.tahun_ajaran_search,
                      label: this.state.tahun_ajaran_search,
                    }
                  : null
              }
              onChange={this.filterTahunAjaran}
              placeholder="Pilih Tahun Ajaran"
              isLoading={this.state.loadingFilter}
            />
          </div>

          {/* Kurikulum - Disabled until Tahun Ajaran selected */}
          <div className="filter-group">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              <span
                className={`inline-flex items-center justify-center w-6 h-6 rounded-full ${this.state.tahun_ajaran_search ? "bg-indigo-100 text-indigo-600" : "bg-gray-100 text-gray-400"} text-xs font-bold mr-2`}
              >
                2
              </span>
              Jenis Kurikulum
            </label>
            <Select
              styles={selectStyles}
              options={dataKurikulum}
              value={
                this.state.filterKurikulumSearch
                  ? {
                      value: this.state.filterKurikulumSearch,
                      label: this.state.filterKurikulumSearch.toUpperCase(),
                    }
                  : null
              }
              onChange={(e) => {
                if (e) {
                  this.filterKurikulume(e);
                } else {
                  this.filterKurikulume("");
                }
              }}
              placeholder={
                this.state.tahun_ajaran_search
                  ? "Pilih Kurikulum"
                  : "Pilih Tahun Ajaran dulu"
              }
              isDisabled={!this.state.tahun_ajaran_search}
            />
          </div>

          {/* Kelas - Disabled until Kurikulum selected */}
          <div className="filter-group">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              <span
                className={`inline-flex items-center justify-center w-6 h-6 rounded-full ${this.state.filterKurikulumSearch ? "bg-indigo-100 text-indigo-600" : "bg-gray-100 text-gray-400"} text-xs font-bold mr-2`}
              >
                3
              </span>
              Kelas
            </label>
            <Select
              styles={selectStyles}
              options={this.state.data_kelas}
              value={
                this.state.kelas_search
                  ? {
                      value: this.state.kelas_search,
                      label: this.state.kelas_search,
                    }
                  : null
              }
              onChange={this.filterKelas}
              placeholder={
                this.state.filterKurikulumSearch
                  ? "Pilih Kelas"
                  : "Pilih Kurikulum dulu"
              }
              isDisabled={!this.state.filterKurikulumSearch}
            />
          </div>

          {/* Peminatan/Jurusan - SMA - Disabled until Kelas selected */}
          {String(this.state.jenjang_id_select) === "4" && (
            <div className="filter-group">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                <span
                  className={`inline-flex items-center justify-center w-6 h-6 rounded-full ${this.state.kelas_search ? "bg-indigo-100 text-indigo-600" : "bg-gray-100 text-gray-400"} text-xs font-bold mr-2`}
                >
                  4
                </span>
                Peminatan
              </label>
              <Select
                styles={selectStyles}
                options={this.state.data_peminatan}
                value={
                  this.state.peminatan_search
                    ? {
                        value: this.state.peminatan_search,
                        label:
                          this.state.peminatan_search_label ||
                          this.state.peminatan_search,
                      }
                    : null
                }
                onChange={this.filterPeminatan}
                placeholder={
                  this.state.kelas_search
                    ? "Pilih Peminatan"
                    : "Pilih Kelas dulu"
                }
                isLoading={this.state.loading_peminatan}
                isDisabled={!this.state.kelas_search}
              />
            </div>
          )}

          {/* SMK - Bidang, Program, Kompetensi */}
          {String(this.state.jenjang_id_select) === "5" &&
            this.renderSMKFilters()}

          {/* Rombel - Disabled until Kelas selected */}
          <div className="filter-group">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              <span
                className={`inline-flex items-center justify-center w-6 h-6 rounded-full ${this.state.kelas_search ? "bg-green-100 text-green-600" : "bg-gray-100 text-gray-400"} text-xs font-bold mr-2`}
              >
                5
              </span>
              Rombel Asal
            </label>
            <Select
              styles={selectStyles}
              options={this.state.data_rombel}
              value={
                this.state.rombel_search
                  ? {
                      value: this.state.rombel_search,
                      label: this.state.rombel_search_label,
                    }
                  : null
              }
              onChange={this.filterRombel}
              placeholder={
                this.state.kelas_search ? "Pilih Rombel" : "Pilih Kelas dulu"
              }
              isLoading={this.state.loading_rombel}
              isDisabled={!this.state.kelas_search}
            />
          </div>
        </div>

        {/* Action Buttons */}
        <div className="mt-6 flex justify-center gap-3">
          <button
            className="px-6 py-3 border-2 border-gray-300 text-gray-700 font-semibold rounded-xl hover:bg-gray-50 transition-all duration-200 flex items-center"
            onClick={this.setResetFilter}
          >
            <i className="bx bx-reset text-xl mr-2"></i>
            Reset Filter
          </button>
          <button
            className={`px-8 py-3 ${this.state.tahun_ajaran_search ? "btn-gradient-indigo hover:shadow-xl transform hover:-translate-y-0.5" : "bg-gray-300 cursor-not-allowed"} text-white font-semibold rounded-xl shadow-lg transition-all duration-200 flex items-center`}
            onClick={this.setFilter}
            disabled={!this.state.tahun_ajaran_search}
          >
            <i className="bx bx-search-alt-2 text-xl mr-2"></i>
            Tampilkan Siswa
          </button>
        </div>
      </div>
    );
  }

  // ============================================
  // PHASE 3: Premium Redesign Methods
  // ============================================

  renderSearchToolbar() {
    const selectedCount = this.state.selectedStudents.size;
    return (
      <div className="glass-card p-4 mb-4 animateFadeInUp">
        <div className="flex flex-wrap items-center justify-between gap-4">
          {/* Search Input */}
          <div className="flex-1 min-w-[200px] max-w-md">
            <div className="relative">
              <i className="bx bx-search absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-lg"></i>
              <input
                type="text"
                placeholder="Cari nama, kode pendaftaran..."
                className="w-full pl-10 pr-4 py-2.5 border border-gray-200 rounded-xl focus:ring-2 focus:ring-indigo-200 focus:border-indigo-400 transition-all text-sm"
                value={this.state.searchQuery}
                onChange={(e) => {
                  this.setState({ searchQuery: e.target.value });
                  // Debounced search
                  clearTimeout(this.searchTimeout);
                  this.searchTimeout = setTimeout(() => {
                    this.searchText({ target: { value: e.target.value } });
                  }, 300);
                }}
              />
            </div>
          </div>

          {/* Pagination Buttons */}
          <div className="flex items-center gap-2">
            <span className="text-sm text-gray-500 mr-2">Tampilkan:</span>
            {[10, 50, 100].map((num) => (
              <button
                key={num}
                onClick={() => this.showMode(num)}
                className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-all ${
                  this.state.mode_show === num
                    ? "bg-indigo-500 text-white shadow-md"
                    : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                }`}
              >
                {num}
              </button>
            ))}
          </div>

          {/* Selection Actions */}
          <div className="flex items-center gap-3">
            <button
              onClick={this.selectAllStudents}
              className="px-4 py-2 bg-indigo-50 text-indigo-600 rounded-lg text-sm font-medium hover:bg-indigo-100 transition-all flex items-center"
            >
              <i className="bx bx-check-double mr-1.5"></i>
              Pilih Semua
            </button>

            {selectedCount > 0 && (
              <button
                onClick={() => this.setState({ selectedStudents: new Map() })}
                className="px-4 py-2 bg-red-50 text-red-600 rounded-lg text-sm font-medium hover:bg-red-100 transition-all flex items-center"
              >
                <i className="bx bx-x mr-1.5"></i>
                Batal ({selectedCount})
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }

  selectAllStudents = () => {
    if (
      this.dt &&
      this.dt.state &&
      this.dt.state.entities &&
      this.dt.state.entities.data
    ) {
      const newSelection = new Map(this.state.selectedStudents);
      this.dt.state.entities.data.forEach((student) => {
        if (!newSelection.has(student.id)) {
          newSelection.set(student.id, student);
        }
      });
      this.setState({ selectedStudents: newSelection });
    }
  };

  renderTargetGrid() {
    const selectedCount = this.state.selectedStudents.size;
    return (
      <div className="glass-card p-6 animateFadeInUp">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center">
            <div className="w-10 h-10 rounded-xl icon-gradient-emerald-teal-600 flex items-center justify-center mr-3 shadow-lg">
              <i className="bx bx-target-lock text-white text-xl"></i>
            </div>
            <div>
              <h3 className="font-bold text-gray-800">Rombel Tujuan</h3>
              <p className="text-xs text-gray-500">
                Drag siswa atau klik untuk memindahkan
              </p>
            </div>
          </div>
          <button
            onClick={() =>
              this.setState({ showFilterPanel: !this.state.showFilterPanel })
            }
            className="px-3 py-1.5 text-indigo-600 bg-indigo-50 rounded-lg text-sm font-medium hover:bg-indigo-100 transition-all flex items-center"
          >
            <i
              className={`bx ${this.state.showFilterPanel ? "bx-chevron-up" : "bx-plus"} mr-1`}
            ></i>
            {this.state.showFilterPanel ? "Tutup" : "Tambah Tujuan"}
          </button>
        </div>

        {/* Add Target Form (Collapsible) */}
        {this.state.showFilterPanel && this.renderAddTargetForm()}

        {/* Target Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 mt-4">
          {this.state.preparedTargets.map((target) => (
            <div
              key={target.id}
              className="relative group border-2 border-dashed border-gray-200 rounded-xl p-4 hover:border-indigo-400 hover:bg-indigo-50/30 transition-all cursor-pointer min-h-[180px]"
              onDragOver={(e) => e.preventDefault()}
              onDrop={(e) => this.handleDropToTarget(e, target.id)}
              onClick={() =>
                selectedCount > 0 && this.assignSelectedToTarget(target.id)
              }
            >
              {/* Target Header */}
              <div className="flex items-start justify-between mb-3">
                <div>
                  <h4 className="font-bold text-gray-800 text-sm">
                    {target.label}
                  </h4>
                  <p className="text-xs text-gray-500">
                    {target.kelas} • {target.tahun_ajaran}
                  </p>
                  <span className="inline-block mt-1 px-2 py-0.5 bg-gray-100 text-gray-600 text-xs rounded-md">
                    {target.kurikulum?.toUpperCase() || "-"}
                  </span>
                </div>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    this.removeTarget(target.id);
                  }}
                  className="opacity-0 group-hover:opacity-100 w-6 h-6 rounded-full bg-red-100 text-red-500 flex items-center justify-center text-xs transition-opacity hover:bg-red-200"
                >
                  <i className="bx bx-x"></i>
                </button>
              </div>

              {/* Assigned Students Count */}
              <div className="absolute bottom-4 left-4 right-4">
                <div className="flex items-center justify-between text-xs">
                  <span className="text-gray-500">
                    <i className="bx bx-user mr-1"></i>
                    {(this.state.assignedStudents[target.id] || []).length}{" "}
                    siswa
                  </span>
                  {selectedCount > 0 && (
                    <span className="text-indigo-600 font-medium animate-pulse">
                      + Klik untuk assign
                    </span>
                  )}
                </div>
              </div>

              {/* Drop Zone Indicator */}
              <div className="absolute inset-0 rounded-xl border-2 border-transparent group-hover:border-indigo-400 pointer-events-none transition-all"></div>
            </div>
          ))}

          {/* Empty State */}
          {this.state.preparedTargets.length === 0 && (
            <div className="col-span-full text-center py-8">
              <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-gray-100 flex items-center justify-center">
                <i className="bx bx-folder-open text-3xl text-gray-400"></i>
              </div>
              <p className="text-gray-500 text-sm">Belum ada rombel tujuan</p>
              <p className="text-gray-400 text-xs mt-1">
                Klik "Tambah Tujuan" untuk mulai
              </p>
            </div>
          )}
        </div>

        {/* Selected Students Summary */}
        {selectedCount > 0 && (
          <div className="mt-6 p-4 bg-gradient-to-r from-indigo-50 to-violet-50 rounded-xl border border-indigo-100">
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <div className="w-10 h-10 rounded-full bg-indigo-500 text-white flex items-center justify-center font-bold mr-3">
                  {selectedCount}
                </div>
                <div>
                  <p className="font-semibold text-gray-800">Siswa Terpilih</p>
                  <p className="text-xs text-gray-500">
                    Siap dipindahkan ke rombel tujuan
                  </p>
                </div>
              </div>
              <button
                onClick={this.handleSubmit}
                disabled={this.state.preparedTargets.length === 0}
                className={`px-6 py-2.5 rounded-xl font-semibold text-sm transition-all flex items-center ${
                  this.state.preparedTargets.length > 0
                    ? "btn-gradient-emerald-600 text-white shadow-lg hover:shadow-xl hover:-translate-y-0.5"
                    : "btn-disabled-gray"
                }`}
              >
                <i className="bx bx-check-circle mr-2"></i>
                Proses Kenaikan
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }

  renderAddTargetForm() {
    return (
      <div className="bg-gray-50 rounded-xl p-4 border border-gray-100 animateFadeInUp">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          {/* Target Tahun Ajaran */}
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1.5">
              Tahun Ajaran
            </label>
            <Select
              styles={selectStyles}
              options={this.state.data_tahun_ajaran}
              value={
                this.state.target_tahun_ajaran
                  ? {
                      value: this.state.target_tahun_ajaran,
                      label: this.state.target_tahun_ajaran,
                    }
                  : null
              }
              onChange={this.handleTargetTahunAjaran}
              placeholder="Pilih..."
            />
          </div>

          {/* Target Kurikulum */}
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1.5">
              Kurikulum
            </label>
            <Select
              styles={selectStyles}
              options={dataKurikulum}
              value={
                this.state.target_kurikulum
                  ? {
                      value: this.state.target_kurikulum,
                      label: this.state.target_kurikulum.toUpperCase(),
                    }
                  : null
              }
              onChange={this.handleTargetKurikulum}
              placeholder="Pilih..."
            />
          </div>

          {/* Target Kelas */}
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1.5">
              Kelas
            </label>
            <Select
              styles={selectStyles}
              options={this.state.data_kelas}
              value={
                this.state.target_kelas
                  ? {
                      value: this.state.target_kelas,
                      label: this.state.target_kelas,
                    }
                  : null
              }
              onChange={this.handleTargetKelas}
              placeholder="Pilih..."
            />
          </div>

          {/* Target Rombel */}
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1.5">
              Rombel Tujuan
            </label>
            <Select
              styles={selectStyles}
              options={this.state.data_target_rombel}
              value={
                this.state.target_rombel_id
                  ? {
                      value: this.state.target_rombel_id,
                      label: this.state.target_rombel_label,
                    }
                  : null
              }
              onChange={this.handleTargetRombel}
              placeholder="Pilih..."
              isLoading={this.state.loading_target_rombel}
            />
          </div>
        </div>

        <div className="mt-4 flex justify-end">
          <button
            onClick={(e) => {
              e.stopPropagation();
              this.addTarget();
            }}
            disabled={!this.state.target_rombel_id}
            className={`px-4 py-2 rounded-lg text-sm font-semibold transition-all flex items-center ${
              this.state.target_rombel_id
                ? "bg-indigo-500 text-white hover:bg-indigo-600 shadow-md"
                : "bg-gray-200 text-gray-400 cursor-not-allowed"
            }`}
          >
            <i className="bx bx-plus mr-1.5"></i>
            Tambahkan Tujuan
          </button>
        </div>
      </div>
    );
  }

  handleDropToTarget = (e, targetId) => {
    e.preventDefault();
    this.assignSelectedToTarget(targetId);
  };

  assignSelectedToTarget = (targetId) => {
    const selectedStudents = Array.from(this.state.selectedStudents.values());
    if (selectedStudents.length === 0) return;

    // Check for duplicates
    const existingInTarget = this.state.assignedStudents[targetId] || [];
    const existingIds = new Set(existingInTarget.map((s) => s.id));

    // Check if any student is already assigned to another target (show which target!)
    let alreadyAssigned = [];
    Object.entries(this.state.assignedStudents).forEach(([tid, students]) => {
      if (tid !== targetId) {
        const targetInfo = this.state.preparedTargets.find((t) => t.id === tid);
        const targetName = targetInfo?.label || "Rombel Lain";
        students.forEach((s) => {
          if (this.state.selectedStudents.has(s.id)) {
            alreadyAssigned.push(`${s.nama} (sudah di ${targetName})`);
          }
        });
      }
    });

    if (alreadyAssigned.length > 0) {
      // Clear selection FIRST to prevent React flush issue
      this.setState({ selectedStudents: new Map() }, () => {
        // Then show alert in callback
        setTimeout(() => {
          this.setState({
            show_alert: true,
            title_alert: "Peringatan Duplikat",
            icon_alert: "warning",
            message_alert: alreadyAssigned.join(", "),
          });
        }, 0);
      });
      return;
    }

    // Add new students (skip duplicates)
    const newStudents = selectedStudents.filter((s) => !existingIds.has(s.id));

    this.setState({
      assignedStudents: {
        ...this.state.assignedStudents,
        [targetId]: [...existingInTarget, ...newStudents],
      },
      selectedStudents: new Map(), // Clear selection after assignment
    });
  };

  // Remove a single student from a target
  removeStudentFromTarget = (studentId, targetId) => {
    const currentStudents = this.state.assignedStudents[targetId] || [];
    this.setState({
      assignedStudents: {
        ...this.state.assignedStudents,
        [targetId]: currentStudents.filter((s) => s.id !== studentId),
      },
    });
  };

  // Move student from one target to another
  moveStudentToTarget = (student, fromTargetId, toTargetId) => {
    const fromStudents = (
      this.state.assignedStudents[fromTargetId] || []
    ).filter((s) => s.id !== student.id);
    const toStudents = [
      ...(this.state.assignedStudents[toTargetId] || []),
      student,
    ];

    this.setState({
      assignedStudents: {
        ...this.state.assignedStudents,
        [fromTargetId]: fromStudents,
        [toTargetId]: toStudents,
      },
    });
  };

  // Toggle expanded state for target card
  toggleTargetExpanded = (targetId) => {
    this.setState((prevState) => ({
      expandedTargets: {
        ...prevState.expandedTargets,
        [targetId]: !prevState.expandedTargets?.[targetId],
      },
    }));
  };

  // Get all assigned student IDs (for hiding from table)
  getAssignedStudentIds = () => {
    const allAssigned = new Set();
    Object.values(this.state.assignedStudents).forEach((students) => {
      students.forEach((s) => allAssigned.add(s.id));
    });
    return allAssigned;
  };

  // Get total assigned count
  getTotalAssignedCount = () => {
    return Object.values(this.state.assignedStudents).reduce(
      (sum, students) => sum + students.length,
      0,
    );
  };

  addTarget = () => {
    if (!this.state.target_rombel_id) return;

    // Validation: Check duplicate
    const exists = this.state.preparedTargets.find(
      (t) => t.id === this.state.target_rombel_id,
    );
    if (exists) {
      // Use setTimeout to prevent React flush error
      setTimeout(() => {
        this.setState({
          show_alert: true,
          title_alert: "Gagal",
          icon_alert: "warning",
          message_alert: "Rombel tujuan sudah ada di daftar",
        });
      }, 0);
      return;
    }

    // Validation: Target Year > Source Year
    if (this.state.tahun_ajaran_search && this.state.target_tahun_ajaran) {
      const sourceStart = parseInt(
        this.state.tahun_ajaran_search.split(" / ")[0],
      );
      const targetStart = parseInt(
        this.state.target_tahun_ajaran.split(" / ")[0],
      );

      if (targetStart <= sourceStart) {
        // Use setTimeout to prevent React flush error
        setTimeout(() => {
          this.setState({
            show_alert: true,
            title_alert: "Validasi Gagal",
            icon_alert: "warning",
            message_alert: "Tahun Ajaran Tujuan harus lebih besar dari Asal",
          });
        }, 0);
        return;
      }
    }

    const newTarget = {
      id: this.state.target_rombel_id,
      label: this.state.target_rombel_label,
      tahun_ajaran: this.state.target_tahun_ajaran,
      kelas: this.state.target_kelas,
      kurikulum: this.state.target_kurikulum,
    };

    this.setState((prevState) => ({
      preparedTargets: [...prevState.preparedTargets, newTarget],
      // Reset selection inputs
      target_rombel_id: "",
      target_rombel_label: "",
    }));
  };

  removeTarget = (id) => {
    // Also remove assigned students for this target
    const newAssigned = { ...this.state.assignedStudents };
    delete newAssigned[id];

    this.setState((prevState) => ({
      preparedTargets: prevState.preparedTargets.filter((t) => t.id !== id),
      assignedStudents: newAssigned,
    }));
  };

  renderSelectionPanel() {
    const selectedCount = this.state.selectedStudents.size;
    const selectedStudents = Array.from(this.state.selectedStudents.values());

    return (
      <div className="glass-card p-6 sticky top-4 bg-white rounded-xl shadow-sm border border-gray-200 h-[calc(100vh-100px)] overflow-y-auto">
        {/* TARGET ROMBEL CONFIGURATION */}
        <div className="mb-6 pb-6 border-b border-gray-100">
          <div className="flex items-center mb-4">
            <div className="w-8 h-8 rounded-lg bg-indigo-100 flex items-center justify-center mr-3">
              <i className="bx bx-cog text-indigo-600"></i>
            </div>
            <h3 className="font-bold text-gray-800">Siapkan Tujuan</h3>
          </div>

          <div className="space-y-4">
            <div>
              <label className="block text-xs font-semibold text-gray-500 mb-1">
                1. Tahun Ajaran Baru
              </label>
              <Select
                styles={selectStyles}
                options={this.state.data_tahun_ajaran}
                value={
                  this.state.target_tahun_ajaran
                    ? {
                        label: this.state.target_tahun_ajaran,
                        value: this.state.target_tahun_ajaran,
                      }
                    : null
                }
                onChange={this.handleTargetTahunAjaran}
                placeholder="Pilih Tahun Ajaran"
                className="text-sm"
              />
            </div>
            <div>
              <label className="block text-xs font-semibold text-gray-500 mb-1">
                2. Jenjang / Kelas Baru
              </label>
              <Select
                styles={selectStyles}
                options={this.state.data_kelas}
                value={
                  this.state.target_kelas
                    ? {
                        label: this.state.target_kelas,
                        value: this.state.target_kelas,
                      }
                    : null
                }
                onChange={this.handleTargetKelas}
                placeholder="Pilih Kelas"
                className="text-sm"
                isDisabled={!this.state.target_tahun_ajaran}
              />
            </div>
            <div>
              <label className="block text-xs font-semibold text-gray-500 mb-1">
                3. Kurikulum
              </label>
              <Select
                styles={selectStyles}
                options={dataKurikulum}
                value={
                  this.state.target_kurikulum
                    ? {
                        label: this.state.target_kurikulum.toUpperCase(),
                        value: this.state.target_kurikulum,
                      }
                    : null
                }
                onChange={this.handleTargetKurikulum}
                placeholder="Pilih Kurikulum"
                className="text-sm"
                isDisabled={!this.state.target_kelas}
              />
            </div>

            <div>
              <label className="block text-xs font-semibold text-gray-500 mb-1">
                4. Rombel Tujuan
              </label>
              <Select
                styles={selectStyles}
                options={this.state.data_target_rombel}
                value={
                  this.state.target_rombel_id
                    ? {
                        label: this.state.target_rombel_label,
                        value: this.state.target_rombel_id,
                      }
                    : null
                }
                onChange={this.handleTargetRombel}
                placeholder="Pilih Rombel Tujuan"
                className="text-sm"
                isDisabled={
                  !this.state.target_kurikulum ||
                  this.state.loading_target_rombel
                }
                isLoading={this.state.loading_target_rombel}
              />
            </div>

            <button
              onClick={this.addTarget}
              disabled={!this.state.target_rombel_id}
              className={`w-full py-2 rounded-lg text-sm font-semibold transition-all flex items-center justify-center ${this.state.target_rombel_id ? "bg-indigo-50 text-indigo-600 hover:bg-indigo-100" : "bg-gray-100 text-gray-400 cursor-not-allowed"}`}
            >
              <i className="bx bx-plus mr-1"></i> Tambahkan Tujuan
            </button>
          </div>
        </div>

        {/* PREPARED TARGETS LIST */}
        <div className="mb-6 pb-6 border-b border-gray-100">
          <div className="flex items-center mb-3">
            <div className="w-8 h-8 rounded-lg bg-orange-100 flex items-center justify-center mr-3">
              <i className="bx bx-list-ul text-orange-600"></i>
            </div>
            <div>
              <h3 className="font-bold text-gray-800">Daftar Tujuan Siap</h3>
              <p className="text-xs text-gray-500">
                Tujuan siswa akan diproses
              </p>
            </div>
          </div>

          {this.state.preparedTargets.length === 0 ? (
            <div className="text-center py-4 bg-gray-50 rounded-lg border border-dashed border-gray-300">
              <p className="text-xs text-gray-400">
                Belum ada tujuan disiapkan
              </p>
            </div>
          ) : (
            <div className="space-y-2">
              {this.state.preparedTargets.map((target, idx) => (
                <div
                  key={target.id}
                  className="bg-white p-3 rounded-lg border border-gray-200 shadow-sm flex justify-between items-start"
                >
                  <div>
                    <p className="text-sm font-bold text-gray-800">
                      {target.label}
                    </p>
                    <p className="text-xs text-gray-500">
                      {target.kelas} | {target.tahun_ajaran}
                    </p>
                  </div>
                  <button
                    onClick={() => this.removeTarget(target.id)}
                    className="text-red-400 hover:text-red-600"
                  >
                    <i className="bx bx-trash"></i>
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* SELECTED STUDENTS */}
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center">
            <div className="w-10 h-10 rounded-xl icon-gradient-emerald-teal flex items-center justify-center mr-3">
              <i className="bx bx-list-check text-white text-xl"></i>
            </div>
            <div>
              <h2 className="text-lg font-bold text-gray-800">
                Siswa Akan Diproses
              </h2>
              <p className="text-sm text-gray-500">
                {selectedCount} siswa dipilih
              </p>
            </div>
          </div>
          {selectedCount > 0 && (
            <button
              className="text-red-500 hover:text-red-700 text-sm font-medium"
              onClick={this.clearAllSelections}
            >
              Hapus Semua
            </button>
          )}
        </div>

        {/* Selected Students List */}
        <div className="max-h-60 overflow-y-auto space-y-2 mb-4 bg-gray-50 rounded-xl p-2 min-h-[100px]">
          {selectedCount === 0 ? (
            <div className="text-center py-8 text-gray-400">
              <i className="bx bx-user-plus text-4xl mb-2"></i>
              <p className="text-sm">Belum ada siswa dipilih</p>
              <p className="text-xs">Centang siswa dari tabel di samping</p>
            </div>
          ) : (
            selectedStudents.map((student) => (
              <div
                key={student.id}
                className="flex items-center justify-between p-3 bg-white rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-all group"
              >
                <div className="flex items-center overflow-hidden">
                  <div className="w-8 h-8 rounded-lg bg-indigo-100 flex-shrink-0 flex items-center justify-center mr-3">
                    <i className="bx bx-user text-indigo-600"></i>
                  </div>
                  <div className="truncate">
                    <p className="font-medium text-gray-800 text-sm truncate">
                      {student.nama}
                    </p>
                    <p className="text-xs text-gray-500">
                      {student.kode_pendaftaran}
                    </p>
                  </div>
                </div>
                <button
                  className="w-6 h-6 rounded-full bg-red-100 text-red-500 hover:bg-red-500 hover:text-white flex items-center justify-center transition-all ml-2"
                  onClick={() => this.removeFromSelection(student.id)}
                >
                  <i className="bx bx-x"></i>
                </button>
              </div>
            ))
          )}
        </div>

        {/* Submit Button */}
        <button
          className={`w-full py-3 ${selectedCount > 0 && this.state.preparedTargets.length > 0 ? "btn-gradient-emerald hover:shadow-xl transform hover:-translate-y-0.5" : "bg-gray-300 cursor-not-allowed"} font-semibold rounded-xl shadow-lg transition-all duration-200 flex items-center justify-center text-white`}
          onClick={this.handleSubmit}
          disabled={
            selectedCount === 0 ||
            this.state.preparedTargets.length === 0 ||
            this.state.loading_naik
          }
        >
          {this.state.loading_naik ? (
            <UserButtonLoading />
          ) : (
            <>
              <i className="bx bx-check-circle text-xl mr-2"></i>
              Proses Kenaikan Kelas
            </>
          )}
        </button>

        {this.state.preparedTargets.length === 0 && selectedCount > 0 && (
          <p className="text-xs text-center text-red-500 mt-2">
            * Siapkan minimal satu tujuan terlebih dahulu
          </p>
        )}
      </div>
    );
  }

  render() {
    const selectedCount = this.state.selectedStudents.size;

    return (
      <div className="min-h-screen">
        {/* Premium Header */}
        <div className="mb-8 animateFadeInUp">
          <div className="flex flex-wrap justify-between items-center gap-4">
            <div>
              <h1 className="text-2xl text-gray-800 font-bold flex items-center">
                <div className="w-12 h-12 rounded-2xl icon-gradient-indigo-purple flex items-center justify-center mr-4">
                  <i className="bx bx-up-arrow-circle text-white text-2xl"></i>
                </div>
                Proses Kenaikan Kelas
              </h1>
              <p className="text-gray-500 text-sm mt-2 ml-16">
                Kelola kenaikan kelas atau kelulusan siswa secara massal
              </p>
            </div>
            <div className="flex gap-3">
              <Link to="alumni">
                <button className="btn-gradient-amber text-white px-5 py-2.5 rounded-xl text-sm font-semibold hover:shadow-lg transition-all flex items-center">
                  <i className="bx bx-medal text-lg mr-2"></i>
                  Data Alumni
                </button>
              </Link>
            </div>
          </div>
        </div>

        {/* Alert */}
        <SweetAlert
          show={this.state.show_alert}
          title={this.state.title_alert}
          text={this.state.message_alert}
          type={this.state.icon_alert}
          confirmBtnText="OK"
          confirmBtnBsStyle="primary"
          onConfirm={() => this.setState({ show_alert: false })}
          onOutsideClick={() => this.setState({ show_alert: false })}
          onEscapeKey={() => this.setState({ show_alert: false })}
        />

        {/* Loading State */}
        {this.state.loadingFilter && (
          <div className="glass-card p-12 text-center animateFadeInUp">
            <div className="w-20 h-20 mx-auto mb-6 rounded-2xl bg-gradient-to-br from-indigo-100 to-violet-100 flex items-center justify-center">
              <i className="bx bx-loader-alt bx-spin text-4xl text-indigo-500"></i>
            </div>
            <h3 className="text-lg font-bold text-gray-700 mb-2">
              Memuat Data...
            </h3>
            <p className="text-gray-500 text-sm">Mohon tunggu sebentar</p>
          </div>
        )}

        {/* Main Content - Vertical Stack Layout */}
        {!this.state.loadingFilter && (
          <div className="space-y-6 animateFadeInUp">
            {/* Section 1: Collapsible Source Filter */}
            <div className="glass-card overflow-hidden">
              <button
                onClick={() =>
                  this.setState({
                    showSourceFilter: !this.state.showSourceFilter,
                  })
                }
                className="w-full px-6 py-4 flex items-center justify-between hover:bg-gray-50 transition-colors"
              >
                <div className="flex items-center">
                  <div className="w-10 h-10 rounded-xl icon-gradient-blue-cyan-br flex items-center justify-center mr-3 shadow-md">
                    <i className="bx bx-filter-alt text-white text-lg"></i>
                  </div>
                  <div className="text-left">
                    <h3 className="font-bold text-gray-800">
                      Filter Rombel Asal
                    </h3>
                    <p className="text-xs text-gray-500">
                      Pilih tahun ajaran, kelas, dan rombel
                    </p>
                  </div>
                </div>
                <i
                  className={`bx ${this.state.showSourceFilter ? "bx-chevron-up" : "bx-chevron-down"} text-2xl text-gray-400`}
                ></i>
              </button>

              {this.state.showSourceFilter && (
                <div className="border-t border-gray-100 p-6">
                  {this.renderFilterPanel()}
                </div>
              )}
            </div>

            {/* Section 2: Students Table with Search */}
            {this.state.showDataTable && (
              <div className="glass-card overflow-hidden animateFadeInUp">
                {/* Table Header */}
                <div className="px-6 py-4 border-b border-gray-100 panel-header-slate">
                  <div className="flex flex-wrap items-center justify-between gap-4">
                    <div className="flex items-center">
                      <div className="w-10 h-10 rounded-xl icon-gradient-indigo-violet flex items-center justify-center mr-3 shadow-md">
                        <i className="bx bx-group text-white text-lg"></i>
                      </div>
                      <div>
                        <h3 className="font-bold text-gray-800">
                          Daftar Siswa
                        </h3>
                        <p className="text-xs text-gray-500">
                          Pilih siswa untuk dipindahkan
                        </p>
                      </div>
                    </div>

                    {/* Inline Controls */}
                    <div className="flex flex-wrap items-center gap-3">
                      {/* Search */}
                      <div className="relative">
                        <i className="bx bx-search absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"></i>
                        <input
                          type="text"
                          placeholder="Cari siswa..."
                          className="pl-9 pr-4 py-2 w-48 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-indigo-200 focus:border-indigo-400 transition-all"
                          value={this.state.searchQuery}
                          onChange={(e) => {
                            const value = e.target.value;
                            this.setState({ searchQuery: value });
                            clearTimeout(this.searchTimeout);
                            this.searchTimeout = setTimeout(() => {
                              this.searchText({ target: { value: value } });
                            }, 300);
                          }}
                        />
                      </div>

                      {/* Pagination */}
                      <div className="flex items-center gap-1 bg-gray-100 rounded-lg p-1">
                        {[10, 50, 100].map((num) => (
                          <button
                            key={num}
                            onClick={() => this.showMode(num)}
                            className={`px-3 py-1 rounded-md text-xs font-medium transition-all ${
                              this.state.mode_show === num
                                ? "bg-white text-indigo-600 shadow-sm"
                                : "text-gray-600 hover:text-gray-800"
                            }`}
                          >
                            {num}
                          </button>
                        ))}
                      </div>

                      {/* Select All */}
                      <button
                        onClick={this.selectAllStudents}
                        className="px-3 py-2 bg-indigo-50 text-indigo-600 rounded-lg text-xs font-medium hover:bg-indigo-100 transition-all flex items-center"
                      >
                        <i className="bx bx-check-double mr-1"></i>
                        Pilih Semua
                      </button>

                      {selectedCount > 0 && (
                        <span className="px-3 py-2 badge-gradient-emerald rounded-lg text-xs font-bold shadow-md">
                          {selectedCount} dipilih
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                {/* Table */}
                <div className="overflow-x-auto">{this.showData()}</div>
              </div>
            )}

            {/* Section 3: Target Rombel - Full Width Below */}
            {this.state.showDataTable && (
              <div className="glass-card overflow-hidden animateFadeInUp relative">
                {/* Target Header */}
                <div className="px-6 py-4 border-b border-gray-100 panel-header-emerald">
                  <div className="flex flex-wrap items-center justify-between gap-4">
                    <div className="flex items-center">
                      <div className="w-10 h-10 rounded-xl icon-gradient-emerald-teal-br flex items-center justify-center mr-3 shadow-md">
                        <i className="bx bx-target-lock text-white text-lg"></i>
                      </div>
                      <div>
                        <h3 className="font-bold text-gray-800">
                          Rombel Tujuan
                        </h3>
                        <p className="text-xs text-gray-500">
                          Klik rombel untuk memindahkan siswa terpilih
                        </p>
                      </div>
                    </div>
                    <button
                      onClick={() =>
                        this.setState({
                          showTargetPanel: !this.state.showTargetPanel,
                        })
                      }
                      className={`px-4 py-2 rounded-lg text-sm font-medium transition-all flex items-center ${
                        this.state.showTargetPanel
                          ? "bg-emerald-100 text-emerald-700"
                          : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                      }`}
                    >
                      <i
                        className={`bx ${this.state.showTargetPanel ? "bx-chevron-up" : "bx-plus"} mr-1`}
                      ></i>
                      {this.state.showTargetPanel
                        ? "Sembunyikan"
                        : "Kelola Tujuan"}
                    </button>
                  </div>
                </div>

                {/* Target Content */}
                {this.state.showTargetPanel && (
                  <div className="p-6">
                    {/* Add Target Form */}
                    <div className="bg-gradient-to-r from-gray-50 to-slate-50 rounded-xl p-5 border border-gray-100 mb-6">
                      <h4 className="text-sm font-semibold text-gray-700 mb-4 flex items-center">
                        <i className="bx bx-plus-circle text-emerald-500 mr-2"></i>
                        Tambah Rombel Tujuan
                      </h4>
                      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
                        <div>
                          <label className="block text-xs font-medium text-gray-600 mb-1.5">
                            Tahun Ajaran
                          </label>
                          <Select
                            styles={selectStyles}
                            options={this.state.data_tahun_ajaran}
                            value={
                              this.state.target_tahun_ajaran
                                ? {
                                    value: this.state.target_tahun_ajaran,
                                    label: this.state.target_tahun_ajaran,
                                  }
                                : null
                            }
                            onChange={this.handleTargetTahunAjaran}
                            placeholder="Pilih..."
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                          />
                        </div>
                        <div>
                          <label className="block text-xs font-medium text-gray-600 mb-1.5">
                            Kurikulum
                          </label>
                          <Select
                            styles={selectStyles}
                            options={dataKurikulum}
                            value={
                              this.state.target_kurikulum
                                ? {
                                    value: this.state.target_kurikulum,
                                    label:
                                      this.state.target_kurikulum.toUpperCase(),
                                  }
                                : null
                            }
                            onChange={this.handleTargetKurikulum}
                            placeholder="Pilih..."
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                          />
                        </div>
                        <div>
                          <label className="block text-xs font-medium text-gray-600 mb-1.5">
                            Kelas
                          </label>
                          <Select
                            styles={selectStyles}
                            options={this.state.data_kelas}
                            value={
                              this.state.target_kelas
                                ? {
                                    value: this.state.target_kelas,
                                    label: this.state.target_kelas,
                                  }
                                : null
                            }
                            onChange={this.handleTargetKelas}
                            placeholder="Pilih..."
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                          />
                        </div>
                        <div>
                          <label className="block text-xs font-medium text-gray-600 mb-1.5">
                            Rombel Tujuan
                          </label>
                          <Select
                            styles={selectStyles}
                            options={this.state.data_target_rombel}
                            value={
                              this.state.target_rombel_id
                                ? {
                                    value: this.state.target_rombel_id,
                                    label: this.state.target_rombel_label,
                                  }
                                : null
                            }
                            onChange={this.handleTargetRombel}
                            placeholder="Pilih..."
                            isLoading={this.state.loading_target_rombel}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            isOptionDisabled={(option) =>
                              this.state.preparedTargets.some(
                                (t) => t.id === option.value,
                              )
                            }
                            formatOptionLabel={(option, { context }) => {
                              const isSelected =
                                this.state.preparedTargets.some(
                                  (t) => t.id === option.value,
                                );
                              return (
                                <div
                                  className={isSelected ? "text-gray-400" : ""}
                                >
                                  {option.label}
                                  {isSelected && (
                                    <span className="ml-2 text-xs">
                                      (sudah dipilih)
                                    </span>
                                  )}
                                </div>
                              );
                            }}
                          />
                        </div>
                        <div className="flex items-end">
                          <button
                            onClick={this.addTarget}
                            disabled={!this.state.target_rombel_id}
                            className={`w-full px-4 py-2.5 rounded-lg text-sm font-semibold transition-all flex items-center justify-center ${
                              this.state.target_rombel_id
                                ? "btn-gradient-emerald-teal text-white hover:shadow-lg"
                                : "btn-disabled-gray"
                            }`}
                          >
                            <i className="bx bx-plus mr-1.5"></i>
                            Tambah
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* Target Cards Grid - Wide Layout */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                      {this.state.preparedTargets.map((target) => {
                        const assignedStudents =
                          this.state.assignedStudents[target.id] || [];
                        const assignedCount = assignedStudents.length;
                        const isExpanded =
                          this.state.expandedTargets?.[target.id];
                        return (
                          <div
                            key={target.id}
                            className={`relative group rounded-xl border-2 transition-all ${
                              selectedCount > 0
                                ? "border-emerald-300 card-gradient-emerald-teal hover:shadow-xl"
                                : "border-gray-200 bg-white hover:border-gray-300 hover:shadow-md"
                            }`}
                          >
                            {/* Card Header - Clickable to assign */}
                            <div
                              onClick={() =>
                                selectedCount > 0 &&
                                this.assignSelectedToTarget(target.id)
                              }
                              className={`p-4 ${selectedCount > 0 ? "cursor-pointer hover:bg-emerald-100/50" : ""}`}
                            >
                              {/* Remove Button */}
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  this.removeTarget(target.id);
                                }}
                                className="absolute top-2 right-2 w-6 h-6 rounded-full bg-red-100 text-red-500 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity hover:bg-red-200"
                              >
                                <i className="bx bx-x text-sm"></i>
                              </button>

                              {/* Target Info */}
                              <h4 className="font-bold text-gray-800 pr-6">
                                {target.label}
                              </h4>
                              <p className="text-xs text-gray-500 mt-1">
                                {target.kelas} • {target.tahun_ajaran}
                              </p>
                              <span className="inline-block mt-2 px-2 py-0.5 bg-indigo-100 text-indigo-700 text-xs font-medium rounded-md">
                                {target.kurikulum?.toUpperCase() || "K13"}
                              </span>

                              {/* Assigned Count & Expand Button */}
                              <div className="mt-3 pt-2 border-t border-gray-100 flex items-center justify-between">
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    this.toggleTargetExpanded(target.id);
                                  }}
                                  className="text-xs text-gray-600 hover:text-indigo-600 flex items-center transition-colors"
                                >
                                  <i
                                    className={`bx ${isExpanded ? "bx-chevron-up" : "bx-chevron-down"} mr-1`}
                                  ></i>
                                  <i className="bx bx-user mr-1"></i>
                                  {assignedCount} siswa
                                </button>
                                {selectedCount > 0 && (
                                  <span className="text-xs text-emerald-600 font-semibold animate-pulse flex items-center">
                                    <i className="bx bx-plus-circle mr-1"></i>
                                    Assign
                                  </span>
                                )}
                              </div>
                            </div>

                            {/* Expanded Student List */}
                            {isExpanded && assignedCount > 0 && (
                              <div className="border-t border-gray-100 p-3 bg-gray-50/50 max-h-48 overflow-y-auto">
                                {assignedStudents.map((student) => (
                                  <div
                                    key={student.id}
                                    className="flex items-center justify-between py-1.5 px-2 hover:bg-white rounded-lg text-xs group/student"
                                  >
                                    <span className="text-gray-700 truncate flex-1 mr-2">
                                      {student.nama}
                                    </span>
                                    <div className="flex items-center gap-1 opacity-0 group-hover/student:opacity-100 transition-opacity">
                                      {/* Move dropdown */}
                                      {this.state.preparedTargets.length >
                                        1 && (
                                        <select
                                          onChange={(e) => {
                                            if (e.target.value) {
                                              this.moveStudentToTarget(
                                                student,
                                                target.id,
                                                e.target.value,
                                              );
                                              e.target.value = "";
                                            }
                                          }}
                                          className="text-xs px-1 py-0.5 border border-gray-200 rounded bg-white text-gray-600 cursor-pointer"
                                          defaultValue=""
                                        >
                                          <option value="" disabled>
                                            Pindah ke...
                                          </option>
                                          {this.state.preparedTargets
                                            .filter((t) => t.id !== target.id)
                                            .map((t) => (
                                              <option key={t.id} value={t.id}>
                                                {t.label}
                                              </option>
                                            ))}
                                        </select>
                                      )}
                                      {/* Remove button */}
                                      <button
                                        onClick={() =>
                                          this.removeStudentFromTarget(
                                            student.id,
                                            target.id,
                                          )
                                        }
                                        className="w-5 h-5 rounded bg-red-100 text-red-500 flex items-center justify-center hover:bg-red-200"
                                        title="Hapus dari target"
                                      >
                                        <i className="bx bx-x text-xs"></i>
                                      </button>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            )}

                            {/* Empty expanded state */}
                            {isExpanded && assignedCount === 0 && (
                              <div className="border-t border-gray-100 p-4 text-center text-xs text-gray-400">
                                Belum ada siswa
                              </div>
                            )}
                          </div>
                        );
                      })}

                      {/* Empty State */}
                      {this.state.preparedTargets.length === 0 && (
                        <div className="col-span-full text-center py-12 border-2 border-dashed border-gray-200 rounded-xl">
                          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-gray-100 flex items-center justify-center">
                            <i className="bx bx-target-lock text-3xl text-gray-400"></i>
                          </div>
                          <p className="text-gray-500 text-sm font-medium">
                            Belum ada rombel tujuan
                          </p>
                          <p className="text-gray-400 text-xs mt-1">
                            Gunakan form di atas untuk menambahkan
                          </p>
                        </div>
                      )}
                    </div>

                    {/* Action Bar - When students are assigned to any target */}
                    {(() => {
                      const totalAssigned = this.getTotalAssignedCount();
                      const hasTargets = this.state.preparedTargets.length > 0;

                      return (
                        totalAssigned > 0 &&
                        hasTargets && (
                          <div className="mt-6 p-5 rounded-xl kenaikan-gradient-bar shadow-xl-safe">
                            <div className="flex flex-wrap items-center justify-between gap-4">
                              <div className="flex items-center text-white">
                                <div className="w-12 h-12 rounded-full bg-white-20 flex items-center justify-center mr-4">
                                  <span className="text-xl font-bold">
                                    {totalAssigned}
                                  </span>
                                </div>
                                <div>
                                  <p className="font-bold">
                                    Siswa Siap Diproses
                                  </p>
                                  <p className="text-sm opacity-80">
                                    {
                                      Object.keys(
                                        this.state.assignedStudents,
                                      ).filter(
                                        (k) =>
                                          (this.state.assignedStudents[k] || [])
                                            .length > 0,
                                      ).length
                                    }{" "}
                                    rombel tujuan
                                  </p>
                                </div>
                              </div>
                              <div className="flex gap-3">
                                <button
                                  onClick={() =>
                                    this.setState({
                                      assignedStudents: {},
                                      selectedStudents: new Map(),
                                    })
                                  }
                                  className="px-5 py-2.5 bg-white-20 text-white rounded-lg text-sm font-medium transition-all hover:bg-white-30"
                                >
                                  <i className="bx bx-x mr-1"></i>
                                  Reset Semua
                                </button>
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    this.handleSubmit();
                                  }}
                                  disabled={this.state.loading_submit}
                                  className="px-6 py-2.5 bg-white text-indigo-600 rounded-lg text-sm font-bold hover:shadow-lg transition-all flex items-center"
                                >
                                  {this.state.loading_submit ? (
                                    <>
                                      <i className="bx bx-loader-alt animate-spin mr-2"></i>{" "}
                                      Memproses...
                                    </>
                                  ) : (
                                    <>
                                      <i className="bx bx-check-circle mr-2"></i>{" "}
                                      Proses Kenaikan
                                    </>
                                  )}
                                </button>
                              </div>
                            </div>
                          </div>
                        )
                      );
                    })()}
                  </div>
                )}

                {/* Confirmation Modal - Absolute positioned within this card */}
                {this.renderConfirmModal()}
              </div>
            )}

            {/* Empty State - When no data table */}
            {!this.state.showDataTable && (
              <div className="glass-card p-16 text-center animateFadeInUp">
                <div className="w-24 h-24 mx-auto mb-8 rounded-3xl bg-gradient-to-br from-indigo-100 via-violet-100 to-purple-100 flex items-center justify-center shadow-inner">
                  <i className="bx bx-filter-alt text-5xl text-indigo-400"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-700 mb-3">
                  Pilih Filter Terlebih Dahulu
                </h3>
                <p className="text-gray-500 text-sm mb-8 max-w-md mx-auto">
                  Klik tombol "Filter Rombel Asal" di atas untuk memilih tahun
                  ajaran, kelas, dan rombel asal siswa
                </p>
                <button
                  onClick={() => this.setState({ showSourceFilter: true })}
                  className="px-8 py-3 bg-gradient-to-r from-indigo-500 via-violet-500 to-purple-600 text-white rounded-xl font-semibold shadow-xl hover:shadow-2xl hover:-translate-y-0.5 transition-all"
                >
                  <i className="bx bx-filter mr-2"></i>
                  Buka Filter
                </button>
              </div>
            )}
          </div>
        )}

        {/* Modals */}

        {this.renderTargetSelectionModal()}
        {this.renderResultModal()}
      </div>
    );
  }
}